var map = {
	"./bg/300": 222,
	"./bg/300.jpg": 222,
	"./bg/350": 223,
	"./bg/350.jpg": 223,
	"./bg/400": 224,
	"./bg/400.jpg": 224,
	"./bg/450": 225,
	"./bg/450.jpg": 225,
	"./bg/bg-1": 226,
	"./bg/bg-1.jpg": 226,
	"./bg/bg-2": 227,
	"./bg/bg-2.jpg": 227,
	"./bg/bg-3": 228,
	"./bg/bg-3.jpg": 228,
	"./bg/bg-4": 229,
	"./bg/bg-4.jpg": 229,
	"./bg/bg-5": 230,
	"./bg/bg-5.jpg": 230,
	"./bg/bg-6": 171,
	"./bg/bg-6.jpg": 1442,
	"./bg/bg-6.png": 171,
	"./bg/bg-7": 231,
	"./bg/bg-7.jpg": 231,
	"./bg/bg-8": 232,
	"./bg/bg-8.jpg": 232,
	"./bg/bg-9": 233,
	"./bg/bg-9.jpg": 233,
	"./bg/demo4-bg-footer": 234,
	"./bg/demo4-bg-footer.jpg": 234,
	"./bg/home-2-bg": 235,
	"./bg/home-2-bg.svg": 235,
	"./bg/sc-home1-bg": 236,
	"./bg/sc-home1-bg.png": 236,
	"./blog/blog1": 237,
	"./blog/blog1.jpg": 237,
	"./blog/blog2": 238,
	"./blog/blog2.jpg": 238,
	"./blog/blog3": 239,
	"./blog/blog3.jpg": 239,
	"./blog/blog4": 240,
	"./blog/blog4.jpg": 240,
	"./blog/blog5": 241,
	"./blog/blog5.jpg": 241,
	"./client-logos/logo1": 242,
	"./client-logos/logo1.png": 242,
	"./client-logos/logo2": 243,
	"./client-logos/logo2.png": 243,
	"./client-logos/logo3": 244,
	"./client-logos/logo3.png": 244,
	"./client-logos/logo4": 245,
	"./client-logos/logo4.png": 245,
	"./client-logos/logo5": 246,
	"./client-logos/logo5.png": 246,
	"./company-logos/logo-1": 247,
	"./company-logos/logo-1.png": 247,
	"./company-logos/logo-2": 248,
	"./company-logos/logo-2.png": 248,
	"./company-logos/logo-3": 249,
	"./company-logos/logo-3.png": 249,
	"./company-logos/logo-4": 250,
	"./company-logos/logo-4.png": 250,
	"./company-logos/logo_client_color": 251,
	"./company-logos/logo_client_color.png": 251,
	"./company-logos/logo_client_white": 252,
	"./company-logos/logo_client_white.png": 252,
	"./company-logos/logo_invoice_dark": 253,
	"./company-logos/logo_invoice_dark.png": 253,
	"./company-logos/logo_invoice_white": 254,
	"./company-logos/logo_invoice_white.png": 254,
	"./demos/demo11/bg-1": 255,
	"./demos/demo11/bg-1.jpg": 255,
	"./demos/demo12/bg-1": 256,
	"./demos/demo12/bg-1.jpg": 256,
	"./demos/demo4/footer": 257,
	"./demos/demo4/footer.jpg": 257,
	"./demos/demo4/header": 258,
	"./demos/demo4/header.jpg": 258,
	"./demos/demo8/bg-1": 259,
	"./demos/demo8/bg-1.jpg": 259,
	"./demos/demo9/bg-300": 260,
	"./demos/demo9/bg-300.jpg": 260,
	"./demos/demo9/bg-350": 261,
	"./demos/demo9/bg-350.jpg": 261,
	"./demos/demo9/bg-400": 262,
	"./demos/demo9/bg-400.jpg": 262,
	"./demos/demo9/bg-450": 263,
	"./demos/demo9/bg-450.jpg": 263,
	"./demos/preview/demo1": 264,
	"./demos/preview/demo1.jpg": 264,
	"./demos/preview/demo10": 265,
	"./demos/preview/demo10.jpg": 265,
	"./demos/preview/demo11": 266,
	"./demos/preview/demo11.jpg": 266,
	"./demos/preview/demo12": 267,
	"./demos/preview/demo12.jpg": 267,
	"./demos/preview/demo13": 268,
	"./demos/preview/demo13.jpg": 268,
	"./demos/preview/demo14": 269,
	"./demos/preview/demo14.jpg": 269,
	"./demos/preview/demo15": 270,
	"./demos/preview/demo15.jpg": 270,
	"./demos/preview/demo16": 271,
	"./demos/preview/demo16.jpg": 271,
	"./demos/preview/demo17": 272,
	"./demos/preview/demo17.jpg": 272,
	"./demos/preview/demo18": 273,
	"./demos/preview/demo18.jpg": 273,
	"./demos/preview/demo19": 274,
	"./demos/preview/demo19.jpg": 274,
	"./demos/preview/demo2": 275,
	"./demos/preview/demo2.jpg": 275,
	"./demos/preview/demo20": 276,
	"./demos/preview/demo20.jpg": 276,
	"./demos/preview/demo21": 277,
	"./demos/preview/demo21.jpg": 277,
	"./demos/preview/demo22": 278,
	"./demos/preview/demo22.jpg": 278,
	"./demos/preview/demo3": 279,
	"./demos/preview/demo3.jpg": 279,
	"./demos/preview/demo4": 280,
	"./demos/preview/demo4.jpg": 280,
	"./demos/preview/demo5": 281,
	"./demos/preview/demo5.jpg": 281,
	"./demos/preview/demo6": 282,
	"./demos/preview/demo6.jpg": 282,
	"./demos/preview/demo7": 283,
	"./demos/preview/demo7.jpg": 283,
	"./demos/preview/demo8": 284,
	"./demos/preview/demo8.jpg": 284,
	"./demos/preview/demo9": 285,
	"./demos/preview/demo9.jpg": 285,
	"./envato/screen1": 286,
	"./envato/screen1.jpg": 286,
	"./envato/screen2": 287,
	"./envato/screen2.jpg": 287,
	"./error/bg1": 288,
	"./error/bg1.jpg": 288,
	"./error/bg2": 289,
	"./error/bg2.jpg": 289,
	"./error/bg3": 290,
	"./error/bg3.jpg": 290,
	"./error/bg4": 291,
	"./error/bg4.jpg": 291,
	"./error/bg5": 292,
	"./error/bg5.jpg": 292,
	"./error/bg6": 293,
	"./error/bg6.jpg": 293,
	"./files/css": 294,
	"./files/css.svg": 294,
	"./files/csv": 295,
	"./files/csv.svg": 295,
	"./files/doc": 296,
	"./files/doc.svg": 296,
	"./files/html": 297,
	"./files/html.svg": 297,
	"./files/javascript": 298,
	"./files/javascript.svg": 298,
	"./files/jpg": 299,
	"./files/jpg.svg": 299,
	"./files/mp4": 300,
	"./files/mp4.svg": 300,
	"./files/pdf": 301,
	"./files/pdf.svg": 301,
	"./files/xml": 302,
	"./files/xml.svg": 302,
	"./files/zip": 303,
	"./files/zip.svg": 303,
	"./flags/001-mauritius": 304,
	"./flags/001-mauritius.svg": 304,
	"./flags/003-austria": 305,
	"./flags/003-austria.svg": 305,
	"./flags/004-oman": 306,
	"./flags/004-oman.svg": 306,
	"./flags/005-ethiopia": 307,
	"./flags/005-ethiopia.svg": 307,
	"./flags/006-tanzania": 308,
	"./flags/006-tanzania.svg": 308,
	"./flags/007-nicaragua": 309,
	"./flags/007-nicaragua.svg": 309,
	"./flags/008-estonia": 310,
	"./flags/008-estonia.svg": 310,
	"./flags/009-uganda": 311,
	"./flags/009-uganda.svg": 311,
	"./flags/010-slovenia": 312,
	"./flags/010-slovenia.svg": 312,
	"./flags/011-zimbabwe": 313,
	"./flags/011-zimbabwe.svg": 313,
	"./flags/012-sao-tome-and-prince": 314,
	"./flags/012-sao-tome-and-prince.svg": 314,
	"./flags/013-italy": 315,
	"./flags/013-italy.svg": 315,
	"./flags/014-wales": 316,
	"./flags/014-wales.svg": 316,
	"./flags/015-el-salvador": 317,
	"./flags/015-el-salvador.svg": 317,
	"./flags/016-nepal": 318,
	"./flags/016-nepal.svg": 318,
	"./flags/017-christmas-island": 319,
	"./flags/017-christmas-island.svg": 319,
	"./flags/018-lebanon": 320,
	"./flags/018-lebanon.svg": 320,
	"./flags/019-ceuta": 321,
	"./flags/019-ceuta.svg": 321,
	"./flags/020-iraq": 322,
	"./flags/020-iraq.svg": 322,
	"./flags/021-cook-islands": 323,
	"./flags/021-cook-islands.svg": 323,
	"./flags/022-syria": 324,
	"./flags/022-syria.svg": 324,
	"./flags/023-cocos-island": 325,
	"./flags/023-cocos-island.svg": 325,
	"./flags/024-honduras": 326,
	"./flags/024-honduras.svg": 326,
	"./flags/025-anguilla": 327,
	"./flags/025-anguilla.svg": 327,
	"./flags/026-qatar": 328,
	"./flags/026-qatar.svg": 328,
	"./flags/027-american-samoa": 329,
	"./flags/027-american-samoa.svg": 329,
	"./flags/028-puerto-rico": 330,
	"./flags/028-puerto-rico.svg": 330,
	"./flags/029-comoros": 331,
	"./flags/029-comoros.svg": 331,
	"./flags/030-north-korea": 332,
	"./flags/030-north-korea.svg": 332,
	"./flags/031-corsica": 333,
	"./flags/031-corsica.svg": 333,
	"./flags/032-zambia": 334,
	"./flags/032-zambia.svg": 334,
	"./flags/033-saint-kitts-and-nevis": 335,
	"./flags/033-saint-kitts-and-nevis.svg": 335,
	"./flags/034-china": 336,
	"./flags/034-china.svg": 336,
	"./flags/035-luxembourg": 337,
	"./flags/035-luxembourg.svg": 337,
	"./flags/036-central-african-republic": 338,
	"./flags/036-central-african-republic.svg": 338,
	"./flags/037-jamaica": 339,
	"./flags/037-jamaica.svg": 339,
	"./flags/038-cape-verde": 340,
	"./flags/038-cape-verde.svg": 340,
	"./flags/039-monaco": 341,
	"./flags/039-monaco.svg": 341,
	"./flags/040-bhutan": 342,
	"./flags/040-bhutan.svg": 342,
	"./flags/041-paraguay": 343,
	"./flags/041-paraguay.svg": 343,
	"./flags/042-aruba": 344,
	"./flags/042-aruba.svg": 344,
	"./flags/043-montserrat": 345,
	"./flags/043-montserrat.svg": 345,
	"./flags/044-latvia": 346,
	"./flags/044-latvia.svg": 346,
	"./flags/045-andorra": 347,
	"./flags/045-andorra.svg": 347,
	"./flags/046-micronesia": 348,
	"./flags/046-micronesia.svg": 348,
	"./flags/047-dominican-republic": 349,
	"./flags/047-dominican-republic.svg": 349,
	"./flags/048-abkhazia": 350,
	"./flags/048-abkhazia.svg": 350,
	"./flags/049-tunisia": 351,
	"./flags/049-tunisia.svg": 351,
	"./flags/050-mauritania": 352,
	"./flags/050-mauritania.svg": 352,
	"./flags/051-cayman-islands": 353,
	"./flags/051-cayman-islands.svg": 353,
	"./flags/052-kosovo": 354,
	"./flags/052-kosovo.svg": 354,
	"./flags/053-ghana": 355,
	"./flags/053-ghana.svg": 355,
	"./flags/054-canary-islands": 356,
	"./flags/054-canary-islands.svg": 356,
	"./flags/055-scotland": 357,
	"./flags/055-scotland.svg": 357,
	"./flags/056-guinea-bissau": 358,
	"./flags/056-guinea-bissau.svg": 358,
	"./flags/057-burundi": 359,
	"./flags/057-burundi.svg": 359,
	"./flags/058-myanmar": 360,
	"./flags/058-myanmar.svg": 360,
	"./flags/059-gabon": 361,
	"./flags/059-gabon.svg": 361,
	"./flags/060-benin": 362,
	"./flags/060-benin.svg": 362,
	"./flags/061-saba-island": 363,
	"./flags/061-saba-island.svg": 363,
	"./flags/062-namibia": 364,
	"./flags/062-namibia.svg": 364,
	"./flags/063-japan": 365,
	"./flags/063-japan.svg": 365,
	"./flags/064-lithuania": 366,
	"./flags/064-lithuania.svg": 366,
	"./flags/065-eritrea": 367,
	"./flags/065-eritrea.svg": 367,
	"./flags/066-chad": 368,
	"./flags/066-chad.svg": 368,
	"./flags/067-kenya": 369,
	"./flags/067-kenya.svg": 369,
	"./flags/068-djibouti": 370,
	"./flags/068-djibouti.svg": 370,
	"./flags/069-british-indian-ocean-territory": 371,
	"./flags/069-british-indian-ocean-territory.svg": 371,
	"./flags/070-tuvalu-1": 372,
	"./flags/070-tuvalu-1.svg": 372,
	"./flags/071-serbia": 373,
	"./flags/071-serbia.svg": 373,
	"./flags/072-bonaire": 374,
	"./flags/072-bonaire.svg": 374,
	"./flags/073-togo": 375,
	"./flags/073-togo.svg": 375,
	"./flags/074-kazakhstan": 376,
	"./flags/074-kazakhstan.svg": 376,
	"./flags/075-antigua-and-barbuda": 377,
	"./flags/075-antigua-and-barbuda.svg": 377,
	"./flags/076-suriname": 378,
	"./flags/076-suriname.svg": 378,
	"./flags/077-jordan": 379,
	"./flags/077-jordan.svg": 379,
	"./flags/078-belize": 380,
	"./flags/078-belize.svg": 380,
	"./flags/079-st-barts": 381,
	"./flags/079-st-barts.svg": 381,
	"./flags/080-iceland": 382,
	"./flags/080-iceland.svg": 382,
	"./flags/081-bermuda": 383,
	"./flags/081-bermuda.svg": 383,
	"./flags/082-united-nations": 384,
	"./flags/082-united-nations.svg": 384,
	"./flags/083-somalia": 385,
	"./flags/083-somalia.svg": 385,
	"./flags/084-barbados": 386,
	"./flags/084-barbados.svg": 386,
	"./flags/085-solomon-islands": 387,
	"./flags/085-solomon-islands.svg": 387,
	"./flags/086-nigeria": 388,
	"./flags/086-nigeria.svg": 388,
	"./flags/087-aland-islands": 389,
	"./flags/087-aland-islands.svg": 389,
	"./flags/088-uruguay": 390,
	"./flags/088-uruguay.svg": 390,
	"./flags/089-sint-maarten": 391,
	"./flags/089-sint-maarten.svg": 391,
	"./flags/090-burkina-faso": 392,
	"./flags/090-burkina-faso.svg": 392,
	"./flags/091-slovakia": 393,
	"./flags/091-slovakia.svg": 393,
	"./flags/092-sierra-leone": 394,
	"./flags/092-sierra-leone.svg": 394,
	"./flags/093-basque-country": 395,
	"./flags/093-basque-country.svg": 395,
	"./flags/094-south-korea": 396,
	"./flags/094-south-korea.svg": 396,
	"./flags/095-pitcairn-islands": 397,
	"./flags/095-pitcairn-islands.svg": 397,
	"./flags/096-mozambique": 398,
	"./flags/096-mozambique.svg": 398,
	"./flags/097-san-marino": 399,
	"./flags/097-san-marino.svg": 399,
	"./flags/098-guatemala": 400,
	"./flags/098-guatemala.svg": 400,
	"./flags/099-albania": 401,
	"./flags/099-albania.svg": 401,
	"./flags/100-pakistan": 402,
	"./flags/100-pakistan.svg": 402,
	"./flags/101-northern-cyprus": 403,
	"./flags/101-northern-cyprus.svg": 403,
	"./flags/102-balearic-islands": 404,
	"./flags/102-balearic-islands.svg": 404,
	"./flags/103-marshall-island": 405,
	"./flags/103-marshall-island.svg": 405,
	"./flags/104-ecuador": 406,
	"./flags/104-ecuador.svg": 406,
	"./flags/105-cameroon": 407,
	"./flags/105-cameroon.svg": 407,
	"./flags/106-panama": 408,
	"./flags/106-panama.svg": 408,
	"./flags/107-kwait": 409,
	"./flags/107-kwait.svg": 409,
	"./flags/108-armenia": 410,
	"./flags/108-armenia.svg": 410,
	"./flags/109-romania": 411,
	"./flags/109-romania.svg": 411,
	"./flags/110-guinea": 412,
	"./flags/110-guinea.svg": 412,
	"./flags/111-afghanistan": 413,
	"./flags/111-afghanistan.svg": 413,
	"./flags/112-laos": 414,
	"./flags/112-laos.svg": 414,
	"./flags/113-greenland": 415,
	"./flags/113-greenland.svg": 415,
	"./flags/114-british-virgin-islands": 416,
	"./flags/114-british-virgin-islands.svg": 416,
	"./flags/115-hungary": 417,
	"./flags/115-hungary.svg": 417,
	"./flags/116-curacao": 418,
	"./flags/116-curacao.svg": 418,
	"./flags/117-angola": 419,
	"./flags/117-angola.svg": 419,
	"./flags/118-malasya": 420,
	"./flags/118-malasya.svg": 420,
	"./flags/119-brunei": 421,
	"./flags/119-brunei.svg": 421,
	"./flags/120-bahamas": 422,
	"./flags/120-bahamas.svg": 422,
	"./flags/121-new-zealand": 423,
	"./flags/121-new-zealand.svg": 423,
	"./flags/123-british-columbia": 424,
	"./flags/123-british-columbia.svg": 424,
	"./flags/124-vatican-city": 425,
	"./flags/124-vatican-city.svg": 425,
	"./flags/125-finland": 426,
	"./flags/125-finland.svg": 426,
	"./flags/126-botswana": 427,
	"./flags/126-botswana.svg": 427,
	"./flags/127-sri-lanka": 428,
	"./flags/127-sri-lanka.svg": 428,
	"./flags/128-spain": 429,
	"./flags/128-spain.svg": 429,
	"./flags/129-ossetia": 430,
	"./flags/129-ossetia.svg": 430,
	"./flags/130-sicily": 431,
	"./flags/130-sicily.svg": 431,
	"./flags/131-chile": 432,
	"./flags/131-chile.svg": 432,
	"./flags/132-bosnia-and-herzegovina": 433,
	"./flags/132-bosnia-and-herzegovina.svg": 433,
	"./flags/133-saudi-arabia": 434,
	"./flags/133-saudi-arabia.svg": 434,
	"./flags/134-liechtenstein": 435,
	"./flags/134-liechtenstein.svg": 435,
	"./flags/135-belarus": 436,
	"./flags/135-belarus.svg": 436,
	"./flags/136-iran": 437,
	"./flags/136-iran.svg": 437,
	"./flags/137-fiji": 438,
	"./flags/137-fiji.svg": 438,
	"./flags/138-bahrain": 439,
	"./flags/138-bahrain.svg": 439,
	"./flags/139-venezuela": 440,
	"./flags/139-venezuela.svg": 440,
	"./flags/140-east-timor": 441,
	"./flags/140-east-timor.svg": 441,
	"./flags/141-azerbaijan": 442,
	"./flags/141-azerbaijan.svg": 442,
	"./flags/142-tibet": 443,
	"./flags/142-tibet.svg": 443,
	"./flags/143-norway": 444,
	"./flags/143-norway.svg": 444,
	"./flags/144-algeria": 445,
	"./flags/144-algeria.svg": 445,
	"./flags/145-ukraine": 446,
	"./flags/145-ukraine.svg": 446,
	"./flags/146-gambia": 447,
	"./flags/146-gambia.svg": 447,
	"./flags/147-bangladesh": 448,
	"./flags/147-bangladesh.svg": 448,
	"./flags/148-madeira": 449,
	"./flags/148-madeira.svg": 449,
	"./flags/149-czech-republic": 450,
	"./flags/149-czech-republic.svg": 450,
	"./flags/150-bolivia": 451,
	"./flags/150-bolivia.svg": 451,
	"./flags/151-united-arab-emirates": 452,
	"./flags/151-united-arab-emirates.svg": 452,
	"./flags/152-kyrgyzstan": 453,
	"./flags/152-kyrgyzstan.svg": 453,
	"./flags/153-cuba": 454,
	"./flags/153-cuba.svg": 454,
	"./flags/154-swaziland": 455,
	"./flags/154-swaziland.svg": 455,
	"./flags/155-israel": 456,
	"./flags/155-israel.svg": 456,
	"./flags/156-costa-rica": 457,
	"./flags/156-costa-rica.svg": 457,
	"./flags/157-republic-of-the-congo": 458,
	"./flags/157-republic-of-the-congo.svg": 458,
	"./flags/158-egypt": 459,
	"./flags/158-egypt.svg": 459,
	"./flags/159-cambodia": 460,
	"./flags/159-cambodia.svg": 460,
	"./flags/160-northern-marianas-islands": 461,
	"./flags/160-northern-marianas-islands.svg": 461,
	"./flags/161-ivory-coast": 462,
	"./flags/161-ivory-coast.svg": 462,
	"./flags/162-germany": 463,
	"./flags/162-germany.svg": 463,
	"./flags/163-papua-new-guinea": 464,
	"./flags/163-papua-new-guinea.svg": 464,
	"./flags/164-croatia": 465,
	"./flags/164-croatia.svg": 465,
	"./flags/165-belgium": 466,
	"./flags/165-belgium.svg": 466,
	"./flags/166-morocco": 467,
	"./flags/166-morocco.svg": 467,
	"./flags/167-macao": 468,
	"./flags/167-macao.svg": 468,
	"./flags/168-bulgaria": 469,
	"./flags/168-bulgaria.svg": 469,
	"./flags/169-liberia": 470,
	"./flags/169-liberia.svg": 470,
	"./flags/170-greece": 471,
	"./flags/170-greece.svg": 471,
	"./flags/171-galapagos-islands": 472,
	"./flags/171-galapagos-islands.svg": 472,
	"./flags/172-st-lucia": 473,
	"./flags/172-st-lucia.svg": 473,
	"./flags/173-mali": 474,
	"./flags/173-mali.svg": 474,
	"./flags/174-denmark": 475,
	"./flags/174-denmark.svg": 475,
	"./flags/175-rapa-nui": 476,
	"./flags/175-rapa-nui.svg": 476,
	"./flags/176-lesotho": 477,
	"./flags/176-lesotho.svg": 477,
	"./flags/177-colombia": 478,
	"./flags/177-colombia.svg": 478,
	"./flags/178-palau": 479,
	"./flags/178-palau.svg": 479,
	"./flags/179-ireland": 480,
	"./flags/179-ireland.svg": 480,
	"./flags/180-french-polynesia": 481,
	"./flags/180-french-polynesia.svg": 481,
	"./flags/181-trinidad-and-tobago": 482,
	"./flags/181-trinidad-and-tobago.svg": 482,
	"./flags/182-niue": 483,
	"./flags/182-niue.svg": 483,
	"./flags/183-hong-kong": 484,
	"./flags/183-hong-kong.svg": 484,
	"./flags/184-sweden": 485,
	"./flags/184-sweden.svg": 485,
	"./flags/185-haiti": 486,
	"./flags/185-haiti.svg": 486,
	"./flags/186-dominica": 487,
	"./flags/186-dominica.svg": 487,
	"./flags/187-vanuatu": 488,
	"./flags/187-vanuatu.svg": 488,
	"./flags/188-peru": 489,
	"./flags/188-peru.svg": 489,
	"./flags/189-equatorial-guinea": 490,
	"./flags/189-equatorial-guinea.svg": 490,
	"./flags/190-uzbekistn": 491,
	"./flags/190-uzbekistn.svg": 491,
	"./flags/191-tonga": 492,
	"./flags/191-tonga.svg": 492,
	"./flags/192-philippines": 493,
	"./flags/192-philippines.svg": 493,
	"./flags/193-norfolk-island": 494,
	"./flags/193-norfolk-island.svg": 494,
	"./flags/194-malta": 495,
	"./flags/194-malta.svg": 495,
	"./flags/195-france": 496,
	"./flags/195-france.svg": 496,
	"./flags/196-tajikistan": 497,
	"./flags/196-tajikistan.svg": 497,
	"./flags/197-melilla": 498,
	"./flags/197-melilla.svg": 498,
	"./flags/198-argentina": 499,
	"./flags/198-argentina.svg": 499,
	"./flags/199-sudan": 500,
	"./flags/199-sudan.svg": 500,
	"./flags/200-south-africa": 501,
	"./flags/200-south-africa.svg": 501,
	"./flags/201-martinique": 502,
	"./flags/201-martinique.svg": 502,
	"./flags/202-taiwan": 503,
	"./flags/202-taiwan.svg": 503,
	"./flags/203-sahrawi-arab-democratic-republic": 504,
	"./flags/203-sahrawi-arab-democratic-republic.svg": 504,
	"./flags/204-guernsey": 505,
	"./flags/204-guernsey.svg": 505,
	"./flags/205-switzerland": 506,
	"./flags/205-switzerland.svg": 506,
	"./flags/206-rwanda": 507,
	"./flags/206-rwanda.svg": 507,
	"./flags/207-guam": 508,
	"./flags/207-guam.svg": 508,
	"./flags/208-palestine": 509,
	"./flags/208-palestine.svg": 509,
	"./flags/209-indonesia": 510,
	"./flags/209-indonesia.svg": 510,
	"./flags/210-grenada": 511,
	"./flags/210-grenada.svg": 511,
	"./flags/211-poland": 512,
	"./flags/211-poland.svg": 512,
	"./flags/212-moldova": 513,
	"./flags/212-moldova.svg": 513,
	"./flags/213-gibraltar": 514,
	"./flags/213-gibraltar.svg": 514,
	"./flags/214-malawi": 515,
	"./flags/214-malawi.svg": 515,
	"./flags/215-falkland-islands": 516,
	"./flags/215-falkland-islands.svg": 516,
	"./flags/216-england": 517,
	"./flags/216-england.svg": 517,
	"./flags/217-virgin-islands": 518,
	"./flags/217-virgin-islands.svg": 518,
	"./flags/218-turkey": 519,
	"./flags/218-turkey.svg": 519,
	"./flags/219-isle-of-man": 520,
	"./flags/219-isle-of-man.svg": 520,
	"./flags/220-vietnam": 521,
	"./flags/220-vietnam.svg": 521,
	"./flags/221-tuvalu": 522,
	"./flags/221-tuvalu.svg": 522,
	"./flags/222-niger": 523,
	"./flags/222-niger.svg": 523,
	"./flags/223-turks-and-caicos": 524,
	"./flags/223-turks-and-caicos.svg": 524,
	"./flags/224-portugal": 525,
	"./flags/224-portugal.svg": 525,
	"./flags/225-maldives": 526,
	"./flags/225-maldives.svg": 526,
	"./flags/226-united-states": 527,
	"./flags/226-united-states.svg": 527,
	"./flags/227-senegal": 528,
	"./flags/227-senegal.svg": 528,
	"./flags/228-nauru": 529,
	"./flags/228-nauru.svg": 529,
	"./flags/229-turkmenistan": 530,
	"./flags/229-turkmenistan.svg": 530,
	"./flags/230-singapore": 531,
	"./flags/230-singapore.svg": 531,
	"./flags/231-libya": 532,
	"./flags/231-libya.svg": 532,
	"./flags/232-yemen": 533,
	"./flags/232-yemen.svg": 533,
	"./flags/233-transnistria": 534,
	"./flags/233-transnistria.svg": 534,
	"./flags/234-australia": 535,
	"./flags/234-australia.svg": 535,
	"./flags/235-tokelau": 536,
	"./flags/235-tokelau.svg": 536,
	"./flags/236-republic-of-macedonia": 537,
	"./flags/236-republic-of-macedonia.svg": 537,
	"./flags/237-netherlands": 538,
	"./flags/237-netherlands.svg": 538,
	"./flags/238-thailand": 539,
	"./flags/238-thailand.svg": 539,
	"./flags/239-montenegro": 540,
	"./flags/239-montenegro.svg": 540,
	"./flags/240-azores-islands": 541,
	"./flags/240-azores-islands.svg": 541,
	"./flags/241-st-vincent-and-the-grenadines": 542,
	"./flags/241-st-vincent-and-the-grenadines.svg": 542,
	"./flags/242-madagascar": 543,
	"./flags/242-madagascar.svg": 543,
	"./flags/243-canada": 544,
	"./flags/243-canada.svg": 544,
	"./flags/244-south-sudan": 545,
	"./flags/244-south-sudan.svg": 545,
	"./flags/245-jersey": 546,
	"./flags/245-jersey.svg": 546,
	"./flags/246-india": 547,
	"./flags/246-india.svg": 547,
	"./flags/247-somaliland": 548,
	"./flags/247-somaliland.svg": 548,
	"./flags/248-russia": 549,
	"./flags/248-russia.svg": 549,
	"./flags/249-democratic-republic-of-congo": 550,
	"./flags/249-democratic-republic-of-congo.svg": 550,
	"./flags/250-sint-eustatius": 551,
	"./flags/250-sint-eustatius.svg": 551,
	"./flags/251-samoa": 552,
	"./flags/251-samoa.svg": 552,
	"./flags/252-mexico": 553,
	"./flags/252-mexico.svg": 553,
	"./flags/253-seychelles": 554,
	"./flags/253-seychelles.svg": 554,
	"./flags/254-nato": 555,
	"./flags/254-nato.svg": 555,
	"./flags/255-brazil": 556,
	"./flags/255-brazil.svg": 556,
	"./flags/256-georgia": 557,
	"./flags/256-georgia.svg": 557,
	"./flags/257-sardinia": 558,
	"./flags/257-sardinia.svg": 558,
	"./flags/258-mongolia": 559,
	"./flags/258-mongolia.svg": 559,
	"./flags/259-european-union": 560,
	"./flags/259-european-union.svg": 560,
	"./flags/260-united-kingdom": 561,
	"./flags/260-united-kingdom.svg": 561,
	"./flags/261-kiribati": 562,
	"./flags/261-kiribati.svg": 562,
	"./flags/262-hawaii": 563,
	"./flags/262-hawaii.svg": 563,
	"./icons/exchange": 564,
	"./icons/exchange.svg": 564,
	"./icons/logout": 565,
	"./icons/logout.svg": 565,
	"./icons/question": 566,
	"./icons/question.svg": 566,
	"./icons/svg/Clothes/Brassiere": 567,
	"./icons/svg/Clothes/Brassiere.svg": 567,
	"./icons/svg/Clothes/Briefcase": 568,
	"./icons/svg/Clothes/Briefcase.svg": 568,
	"./icons/svg/Clothes/Cap": 569,
	"./icons/svg/Clothes/Cap.svg": 569,
	"./icons/svg/Clothes/Crown": 570,
	"./icons/svg/Clothes/Crown.svg": 570,
	"./icons/svg/Clothes/Dress": 571,
	"./icons/svg/Clothes/Dress.svg": 571,
	"./icons/svg/Clothes/Hanger": 572,
	"./icons/svg/Clothes/Hanger.svg": 572,
	"./icons/svg/Clothes/Hat": 573,
	"./icons/svg/Clothes/Hat.svg": 573,
	"./icons/svg/Clothes/Panties": 574,
	"./icons/svg/Clothes/Panties.svg": 574,
	"./icons/svg/Clothes/Shirt": 575,
	"./icons/svg/Clothes/Shirt.svg": 575,
	"./icons/svg/Clothes/Shoes": 576,
	"./icons/svg/Clothes/Shoes.svg": 576,
	"./icons/svg/Clothes/Shorts": 577,
	"./icons/svg/Clothes/Shorts.svg": 577,
	"./icons/svg/Clothes/Sneakers": 578,
	"./icons/svg/Clothes/Sneakers.svg": 578,
	"./icons/svg/Clothes/Socks": 579,
	"./icons/svg/Clothes/Socks.svg": 579,
	"./icons/svg/Clothes/Sun-glasses": 580,
	"./icons/svg/Clothes/Sun-glasses.svg": 580,
	"./icons/svg/Clothes/T-Shirt": 581,
	"./icons/svg/Clothes/T-Shirt.svg": 581,
	"./icons/svg/Clothes/Tie": 582,
	"./icons/svg/Clothes/Tie.svg": 582,
	"./icons/svg/Code/Backspace": 583,
	"./icons/svg/Code/Backspace.svg": 583,
	"./icons/svg/Code/CMD": 584,
	"./icons/svg/Code/CMD.svg": 584,
	"./icons/svg/Code/Code": 585,
	"./icons/svg/Code/Code.svg": 585,
	"./icons/svg/Code/Commit": 586,
	"./icons/svg/Code/Commit.svg": 586,
	"./icons/svg/Code/Compiling": 587,
	"./icons/svg/Code/Compiling.svg": 587,
	"./icons/svg/Code/Control": 588,
	"./icons/svg/Code/Control.svg": 588,
	"./icons/svg/Code/Done-circle": 589,
	"./icons/svg/Code/Done-circle.svg": 589,
	"./icons/svg/Code/Error-circle": 590,
	"./icons/svg/Code/Error-circle.svg": 590,
	"./icons/svg/Code/Git1": 591,
	"./icons/svg/Code/Git1.svg": 591,
	"./icons/svg/Code/Git2": 592,
	"./icons/svg/Code/Git2.svg": 592,
	"./icons/svg/Code/Git3": 593,
	"./icons/svg/Code/Git3.svg": 593,
	"./icons/svg/Code/Git4": 594,
	"./icons/svg/Code/Git4.svg": 594,
	"./icons/svg/Code/Github": 595,
	"./icons/svg/Code/Github.svg": 595,
	"./icons/svg/Code/Info-circle": 596,
	"./icons/svg/Code/Info-circle.svg": 596,
	"./icons/svg/Code/Left-circle": 597,
	"./icons/svg/Code/Left-circle.svg": 597,
	"./icons/svg/Code/Loading": 598,
	"./icons/svg/Code/Loading.svg": 598,
	"./icons/svg/Code/Lock-circle": 599,
	"./icons/svg/Code/Lock-circle.svg": 599,
	"./icons/svg/Code/Lock-overturning": 600,
	"./icons/svg/Code/Lock-overturning.svg": 600,
	"./icons/svg/Code/Minus": 601,
	"./icons/svg/Code/Minus.svg": 601,
	"./icons/svg/Code/Option": 602,
	"./icons/svg/Code/Option.svg": 602,
	"./icons/svg/Code/Plus": 603,
	"./icons/svg/Code/Plus.svg": 603,
	"./icons/svg/Code/Puzzle": 604,
	"./icons/svg/Code/Puzzle.svg": 604,
	"./icons/svg/Code/Question-circle": 605,
	"./icons/svg/Code/Question-circle.svg": 605,
	"./icons/svg/Code/Right-circle": 606,
	"./icons/svg/Code/Right-circle.svg": 606,
	"./icons/svg/Code/Settings4": 607,
	"./icons/svg/Code/Settings4.svg": 607,
	"./icons/svg/Code/Shift": 608,
	"./icons/svg/Code/Shift.svg": 608,
	"./icons/svg/Code/Spy": 609,
	"./icons/svg/Code/Spy.svg": 609,
	"./icons/svg/Code/Stop": 610,
	"./icons/svg/Code/Stop.svg": 610,
	"./icons/svg/Code/Terminal": 611,
	"./icons/svg/Code/Terminal.svg": 611,
	"./icons/svg/Code/Thunder-circle": 612,
	"./icons/svg/Code/Thunder-circle.svg": 612,
	"./icons/svg/Code/Time-schedule": 613,
	"./icons/svg/Code/Time-schedule.svg": 613,
	"./icons/svg/Code/Warning-1-circle": 614,
	"./icons/svg/Code/Warning-1-circle.svg": 614,
	"./icons/svg/Code/Warning-2": 615,
	"./icons/svg/Code/Warning-2.svg": 615,
	"./icons/svg/Communication/Active-call": 616,
	"./icons/svg/Communication/Active-call.svg": 616,
	"./icons/svg/Communication/Add-user": 617,
	"./icons/svg/Communication/Add-user.svg": 617,
	"./icons/svg/Communication/Address-card": 618,
	"./icons/svg/Communication/Address-card.svg": 618,
	"./icons/svg/Communication/Adress-book1": 619,
	"./icons/svg/Communication/Adress-book1.svg": 619,
	"./icons/svg/Communication/Adress-book2": 620,
	"./icons/svg/Communication/Adress-book2.svg": 620,
	"./icons/svg/Communication/Archive": 621,
	"./icons/svg/Communication/Archive.svg": 621,
	"./icons/svg/Communication/Call": 622,
	"./icons/svg/Communication/Call#1": 623,
	"./icons/svg/Communication/Call#1.svg": 623,
	"./icons/svg/Communication/Call.svg": 622,
	"./icons/svg/Communication/Chat-check": 624,
	"./icons/svg/Communication/Chat-check.svg": 624,
	"./icons/svg/Communication/Chat-error": 625,
	"./icons/svg/Communication/Chat-error.svg": 625,
	"./icons/svg/Communication/Chat-locked": 626,
	"./icons/svg/Communication/Chat-locked.svg": 626,
	"./icons/svg/Communication/Chat-smile": 627,
	"./icons/svg/Communication/Chat-smile.svg": 627,
	"./icons/svg/Communication/Chat1": 628,
	"./icons/svg/Communication/Chat1.svg": 628,
	"./icons/svg/Communication/Chat2": 629,
	"./icons/svg/Communication/Chat2.svg": 629,
	"./icons/svg/Communication/Chat4": 630,
	"./icons/svg/Communication/Chat4.svg": 630,
	"./icons/svg/Communication/Chat5": 631,
	"./icons/svg/Communication/Chat5.svg": 631,
	"./icons/svg/Communication/Chat6": 632,
	"./icons/svg/Communication/Chat6.svg": 632,
	"./icons/svg/Communication/Clipboard-check": 633,
	"./icons/svg/Communication/Clipboard-check.svg": 633,
	"./icons/svg/Communication/Clipboard-list": 634,
	"./icons/svg/Communication/Clipboard-list.svg": 634,
	"./icons/svg/Communication/Contact1": 635,
	"./icons/svg/Communication/Contact1.svg": 635,
	"./icons/svg/Communication/Delete-user": 636,
	"./icons/svg/Communication/Delete-user.svg": 636,
	"./icons/svg/Communication/Dial-numbers": 637,
	"./icons/svg/Communication/Dial-numbers.svg": 637,
	"./icons/svg/Communication/Flag": 638,
	"./icons/svg/Communication/Flag.svg": 638,
	"./icons/svg/Communication/Forward": 639,
	"./icons/svg/Communication/Forward.svg": 639,
	"./icons/svg/Communication/Group": 640,
	"./icons/svg/Communication/Group-chat": 641,
	"./icons/svg/Communication/Group-chat.svg": 641,
	"./icons/svg/Communication/Group.svg": 640,
	"./icons/svg/Communication/Incoming-box": 642,
	"./icons/svg/Communication/Incoming-box.svg": 642,
	"./icons/svg/Communication/Incoming-call": 643,
	"./icons/svg/Communication/Incoming-call.svg": 643,
	"./icons/svg/Communication/Incoming-mail": 644,
	"./icons/svg/Communication/Incoming-mail.svg": 644,
	"./icons/svg/Communication/Mail": 645,
	"./icons/svg/Communication/Mail-at": 646,
	"./icons/svg/Communication/Mail-at.svg": 646,
	"./icons/svg/Communication/Mail-attachment": 647,
	"./icons/svg/Communication/Mail-attachment.svg": 647,
	"./icons/svg/Communication/Mail-box": 648,
	"./icons/svg/Communication/Mail-box.svg": 648,
	"./icons/svg/Communication/Mail-error": 649,
	"./icons/svg/Communication/Mail-error.svg": 649,
	"./icons/svg/Communication/Mail-heart": 650,
	"./icons/svg/Communication/Mail-heart.svg": 650,
	"./icons/svg/Communication/Mail-locked": 651,
	"./icons/svg/Communication/Mail-locked.svg": 651,
	"./icons/svg/Communication/Mail-notification": 652,
	"./icons/svg/Communication/Mail-notification.svg": 652,
	"./icons/svg/Communication/Mail-opened": 653,
	"./icons/svg/Communication/Mail-opened.svg": 653,
	"./icons/svg/Communication/Mail-unocked": 654,
	"./icons/svg/Communication/Mail-unocked.svg": 654,
	"./icons/svg/Communication/Mail.svg": 645,
	"./icons/svg/Communication/Missed-call": 655,
	"./icons/svg/Communication/Missed-call.svg": 655,
	"./icons/svg/Communication/Outgoing-box": 656,
	"./icons/svg/Communication/Outgoing-box.svg": 656,
	"./icons/svg/Communication/Outgoing-call": 657,
	"./icons/svg/Communication/Outgoing-call.svg": 657,
	"./icons/svg/Communication/Outgoing-mail": 658,
	"./icons/svg/Communication/Outgoing-mail.svg": 658,
	"./icons/svg/Communication/RSS": 659,
	"./icons/svg/Communication/RSS.svg": 659,
	"./icons/svg/Communication/Readed-mail": 660,
	"./icons/svg/Communication/Readed-mail.svg": 660,
	"./icons/svg/Communication/Reply": 661,
	"./icons/svg/Communication/Reply-all": 662,
	"./icons/svg/Communication/Reply-all.svg": 662,
	"./icons/svg/Communication/Reply.svg": 661,
	"./icons/svg/Communication/Right": 663,
	"./icons/svg/Communication/Right.svg": 663,
	"./icons/svg/Communication/Safe-chat": 664,
	"./icons/svg/Communication/Safe-chat.svg": 664,
	"./icons/svg/Communication/Send": 665,
	"./icons/svg/Communication/Send.svg": 665,
	"./icons/svg/Communication/Sending": 666,
	"./icons/svg/Communication/Sending mail": 667,
	"./icons/svg/Communication/Sending mail.svg": 667,
	"./icons/svg/Communication/Sending.svg": 666,
	"./icons/svg/Communication/Share": 668,
	"./icons/svg/Communication/Share.svg": 668,
	"./icons/svg/Communication/Shield-thunder": 669,
	"./icons/svg/Communication/Shield-thunder.svg": 669,
	"./icons/svg/Communication/Shield-user": 670,
	"./icons/svg/Communication/Shield-user.svg": 670,
	"./icons/svg/Communication/Snoozed-mail": 671,
	"./icons/svg/Communication/Snoozed-mail.svg": 671,
	"./icons/svg/Communication/Spam": 672,
	"./icons/svg/Communication/Spam.svg": 672,
	"./icons/svg/Communication/Thumbtack": 673,
	"./icons/svg/Communication/Thumbtack.svg": 673,
	"./icons/svg/Communication/Urgent-mail": 674,
	"./icons/svg/Communication/Urgent-mail.svg": 674,
	"./icons/svg/Communication/Write": 675,
	"./icons/svg/Communication/Write.svg": 675,
	"./icons/svg/Cooking/Baking-glove": 676,
	"./icons/svg/Cooking/Baking-glove.svg": 676,
	"./icons/svg/Cooking/Bowl": 677,
	"./icons/svg/Cooking/Bowl.svg": 677,
	"./icons/svg/Cooking/Chef": 678,
	"./icons/svg/Cooking/Chef.svg": 678,
	"./icons/svg/Cooking/Cooking-book": 679,
	"./icons/svg/Cooking/Cooking-book.svg": 679,
	"./icons/svg/Cooking/Cooking-pot": 680,
	"./icons/svg/Cooking/Cooking-pot.svg": 680,
	"./icons/svg/Cooking/Cutting board": 681,
	"./icons/svg/Cooking/Cutting board.svg": 681,
	"./icons/svg/Cooking/Dinner": 682,
	"./icons/svg/Cooking/Dinner.svg": 682,
	"./icons/svg/Cooking/Dish": 683,
	"./icons/svg/Cooking/Dish.svg": 683,
	"./icons/svg/Cooking/Dishes": 684,
	"./icons/svg/Cooking/Dishes.svg": 684,
	"./icons/svg/Cooking/Fork": 685,
	"./icons/svg/Cooking/Fork-spoon": 686,
	"./icons/svg/Cooking/Fork-spoon-knife": 687,
	"./icons/svg/Cooking/Fork-spoon-knife.svg": 687,
	"./icons/svg/Cooking/Fork-spoon.svg": 686,
	"./icons/svg/Cooking/Fork.svg": 685,
	"./icons/svg/Cooking/Frying-pan": 688,
	"./icons/svg/Cooking/Frying-pan.svg": 688,
	"./icons/svg/Cooking/Grater": 689,
	"./icons/svg/Cooking/Grater.svg": 689,
	"./icons/svg/Cooking/Kitchen-scale": 690,
	"./icons/svg/Cooking/Kitchen-scale.svg": 690,
	"./icons/svg/Cooking/Knife1": 691,
	"./icons/svg/Cooking/Knife1.svg": 691,
	"./icons/svg/Cooking/Knife2": 692,
	"./icons/svg/Cooking/Knife2.svg": 692,
	"./icons/svg/Cooking/KnifeAndFork1": 693,
	"./icons/svg/Cooking/KnifeAndFork1.svg": 693,
	"./icons/svg/Cooking/KnifeAndFork2": 694,
	"./icons/svg/Cooking/KnifeAndFork2.svg": 694,
	"./icons/svg/Cooking/Ladle": 695,
	"./icons/svg/Cooking/Ladle.svg": 695,
	"./icons/svg/Cooking/Rolling-pin": 696,
	"./icons/svg/Cooking/Rolling-pin.svg": 696,
	"./icons/svg/Cooking/Saucepan": 697,
	"./icons/svg/Cooking/Saucepan.svg": 697,
	"./icons/svg/Cooking/Shovel": 698,
	"./icons/svg/Cooking/Shovel.svg": 698,
	"./icons/svg/Cooking/Sieve": 699,
	"./icons/svg/Cooking/Sieve.svg": 699,
	"./icons/svg/Cooking/Spoon": 700,
	"./icons/svg/Cooking/Spoon.svg": 700,
	"./icons/svg/Design/Adjust": 701,
	"./icons/svg/Design/Adjust.svg": 701,
	"./icons/svg/Design/Anchor-center": 702,
	"./icons/svg/Design/Anchor-center-down": 703,
	"./icons/svg/Design/Anchor-center-down.svg": 703,
	"./icons/svg/Design/Anchor-center-up": 704,
	"./icons/svg/Design/Anchor-center-up.svg": 704,
	"./icons/svg/Design/Anchor-center.svg": 702,
	"./icons/svg/Design/Anchor-left": 705,
	"./icons/svg/Design/Anchor-left-down": 706,
	"./icons/svg/Design/Anchor-left-down.svg": 706,
	"./icons/svg/Design/Anchor-left-up": 707,
	"./icons/svg/Design/Anchor-left-up.svg": 707,
	"./icons/svg/Design/Anchor-left.svg": 705,
	"./icons/svg/Design/Anchor-right": 708,
	"./icons/svg/Design/Anchor-right-down": 709,
	"./icons/svg/Design/Anchor-right-down.svg": 709,
	"./icons/svg/Design/Anchor-right-up": 710,
	"./icons/svg/Design/Anchor-right-up.svg": 710,
	"./icons/svg/Design/Anchor-right.svg": 708,
	"./icons/svg/Design/Arrows": 711,
	"./icons/svg/Design/Arrows.svg": 711,
	"./icons/svg/Design/Bezier-curve": 712,
	"./icons/svg/Design/Bezier-curve.svg": 712,
	"./icons/svg/Design/Border": 713,
	"./icons/svg/Design/Border.svg": 713,
	"./icons/svg/Design/Brush": 714,
	"./icons/svg/Design/Brush.svg": 714,
	"./icons/svg/Design/Bucket": 715,
	"./icons/svg/Design/Bucket.svg": 715,
	"./icons/svg/Design/Cap-1": 716,
	"./icons/svg/Design/Cap-1.svg": 716,
	"./icons/svg/Design/Cap-2": 717,
	"./icons/svg/Design/Cap-2.svg": 717,
	"./icons/svg/Design/Cap-3": 718,
	"./icons/svg/Design/Cap-3.svg": 718,
	"./icons/svg/Design/Circle": 719,
	"./icons/svg/Design/Circle.svg": 719,
	"./icons/svg/Design/Color": 720,
	"./icons/svg/Design/Color-profile": 721,
	"./icons/svg/Design/Color-profile.svg": 721,
	"./icons/svg/Design/Color.svg": 720,
	"./icons/svg/Design/Component": 722,
	"./icons/svg/Design/Component.svg": 722,
	"./icons/svg/Design/Crop": 723,
	"./icons/svg/Design/Crop.svg": 723,
	"./icons/svg/Design/Difference": 724,
	"./icons/svg/Design/Difference.svg": 724,
	"./icons/svg/Design/Edit": 725,
	"./icons/svg/Design/Edit.svg": 725,
	"./icons/svg/Design/Eraser": 726,
	"./icons/svg/Design/Eraser.svg": 726,
	"./icons/svg/Design/Flatten": 727,
	"./icons/svg/Design/Flatten.svg": 727,
	"./icons/svg/Design/Flip-horizontal": 728,
	"./icons/svg/Design/Flip-horizontal.svg": 728,
	"./icons/svg/Design/Flip-vertical": 729,
	"./icons/svg/Design/Flip-vertical.svg": 729,
	"./icons/svg/Design/Horizontal": 730,
	"./icons/svg/Design/Horizontal.svg": 730,
	"./icons/svg/Design/Image": 731,
	"./icons/svg/Design/Image.svg": 731,
	"./icons/svg/Design/Interselect": 732,
	"./icons/svg/Design/Interselect.svg": 732,
	"./icons/svg/Design/Join-1": 733,
	"./icons/svg/Design/Join-1.svg": 733,
	"./icons/svg/Design/Join-2": 734,
	"./icons/svg/Design/Join-2.svg": 734,
	"./icons/svg/Design/Join-3": 735,
	"./icons/svg/Design/Join-3.svg": 735,
	"./icons/svg/Design/Layers": 736,
	"./icons/svg/Design/Layers.svg": 736,
	"./icons/svg/Design/Line": 737,
	"./icons/svg/Design/Line.svg": 737,
	"./icons/svg/Design/Magic": 738,
	"./icons/svg/Design/Magic.svg": 738,
	"./icons/svg/Design/Mask": 739,
	"./icons/svg/Design/Mask.svg": 739,
	"./icons/svg/Design/Patch": 740,
	"./icons/svg/Design/Patch.svg": 740,
	"./icons/svg/Design/Pen-tool-vector": 741,
	"./icons/svg/Design/Pen-tool-vector.svg": 741,
	"./icons/svg/Design/PenAndRuller": 742,
	"./icons/svg/Design/PenAndRuller.svg": 742,
	"./icons/svg/Design/Pencil": 743,
	"./icons/svg/Design/Pencil.svg": 743,
	"./icons/svg/Design/Picker": 744,
	"./icons/svg/Design/Picker.svg": 744,
	"./icons/svg/Design/Pixels": 745,
	"./icons/svg/Design/Pixels.svg": 745,
	"./icons/svg/Design/Polygon": 746,
	"./icons/svg/Design/Polygon.svg": 746,
	"./icons/svg/Design/Position": 747,
	"./icons/svg/Design/Position.svg": 747,
	"./icons/svg/Design/Rectangle": 748,
	"./icons/svg/Design/Rectangle.svg": 748,
	"./icons/svg/Design/Saturation": 749,
	"./icons/svg/Design/Saturation.svg": 749,
	"./icons/svg/Design/Select": 750,
	"./icons/svg/Design/Select.svg": 750,
	"./icons/svg/Design/Sketch": 751,
	"./icons/svg/Design/Sketch.svg": 751,
	"./icons/svg/Design/Stamp": 752,
	"./icons/svg/Design/Stamp.svg": 752,
	"./icons/svg/Design/Substract": 753,
	"./icons/svg/Design/Substract.svg": 753,
	"./icons/svg/Design/Target": 754,
	"./icons/svg/Design/Target.svg": 754,
	"./icons/svg/Design/Triangle": 755,
	"./icons/svg/Design/Triangle.svg": 755,
	"./icons/svg/Design/Union": 756,
	"./icons/svg/Design/Union.svg": 756,
	"./icons/svg/Design/Vertical": 757,
	"./icons/svg/Design/Vertical.svg": 757,
	"./icons/svg/Design/ZoomMinus": 758,
	"./icons/svg/Design/ZoomMinus.svg": 758,
	"./icons/svg/Design/ZoomPlus": 759,
	"./icons/svg/Design/ZoomPlus.svg": 759,
	"./icons/svg/Devices/Airpods": 760,
	"./icons/svg/Devices/Airpods.svg": 760,
	"./icons/svg/Devices/Android": 761,
	"./icons/svg/Devices/Android.svg": 761,
	"./icons/svg/Devices/Apple-Watch": 762,
	"./icons/svg/Devices/Apple-Watch.svg": 762,
	"./icons/svg/Devices/Battery-charging": 763,
	"./icons/svg/Devices/Battery-charging.svg": 763,
	"./icons/svg/Devices/Battery-empty": 764,
	"./icons/svg/Devices/Battery-empty.svg": 764,
	"./icons/svg/Devices/Battery-full": 765,
	"./icons/svg/Devices/Battery-full.svg": 765,
	"./icons/svg/Devices/Battery-half": 766,
	"./icons/svg/Devices/Battery-half.svg": 766,
	"./icons/svg/Devices/Bluetooth": 767,
	"./icons/svg/Devices/Bluetooth.svg": 767,
	"./icons/svg/Devices/CPU1": 768,
	"./icons/svg/Devices/CPU1.svg": 768,
	"./icons/svg/Devices/CPU2": 769,
	"./icons/svg/Devices/CPU2.svg": 769,
	"./icons/svg/Devices/Camera": 770,
	"./icons/svg/Devices/Camera.svg": 770,
	"./icons/svg/Devices/Cardboard-vr": 771,
	"./icons/svg/Devices/Cardboard-vr.svg": 771,
	"./icons/svg/Devices/Cassete": 772,
	"./icons/svg/Devices/Cassete.svg": 772,
	"./icons/svg/Devices/Diagnostics": 773,
	"./icons/svg/Devices/Diagnostics.svg": 773,
	"./icons/svg/Devices/Display1": 774,
	"./icons/svg/Devices/Display1.svg": 774,
	"./icons/svg/Devices/Display2": 775,
	"./icons/svg/Devices/Display2.svg": 775,
	"./icons/svg/Devices/Display3": 776,
	"./icons/svg/Devices/Display3.svg": 776,
	"./icons/svg/Devices/Gameboy": 777,
	"./icons/svg/Devices/Gameboy.svg": 777,
	"./icons/svg/Devices/Gamepad1": 778,
	"./icons/svg/Devices/Gamepad1.svg": 778,
	"./icons/svg/Devices/Gamepad2": 779,
	"./icons/svg/Devices/Gamepad2.svg": 779,
	"./icons/svg/Devices/Generator": 780,
	"./icons/svg/Devices/Generator.svg": 780,
	"./icons/svg/Devices/Hard-drive": 781,
	"./icons/svg/Devices/Hard-drive.svg": 781,
	"./icons/svg/Devices/Headphones": 782,
	"./icons/svg/Devices/Headphones.svg": 782,
	"./icons/svg/Devices/Homepod": 783,
	"./icons/svg/Devices/Homepod.svg": 783,
	"./icons/svg/Devices/Keyboard": 784,
	"./icons/svg/Devices/Keyboard.svg": 784,
	"./icons/svg/Devices/LTE1": 785,
	"./icons/svg/Devices/LTE1.svg": 785,
	"./icons/svg/Devices/LTE2": 786,
	"./icons/svg/Devices/LTE2.svg": 786,
	"./icons/svg/Devices/Laptop": 787,
	"./icons/svg/Devices/Laptop-macbook": 788,
	"./icons/svg/Devices/Laptop-macbook.svg": 788,
	"./icons/svg/Devices/Laptop.svg": 787,
	"./icons/svg/Devices/Mic": 789,
	"./icons/svg/Devices/Mic.svg": 789,
	"./icons/svg/Devices/Midi": 790,
	"./icons/svg/Devices/Midi.svg": 790,
	"./icons/svg/Devices/Mouse": 791,
	"./icons/svg/Devices/Mouse.svg": 791,
	"./icons/svg/Devices/Phone": 792,
	"./icons/svg/Devices/Phone.svg": 792,
	"./icons/svg/Devices/Printer": 793,
	"./icons/svg/Devices/Printer.svg": 793,
	"./icons/svg/Devices/Radio": 794,
	"./icons/svg/Devices/Radio.svg": 794,
	"./icons/svg/Devices/Router1": 795,
	"./icons/svg/Devices/Router1.svg": 795,
	"./icons/svg/Devices/Router2": 796,
	"./icons/svg/Devices/Router2.svg": 796,
	"./icons/svg/Devices/SD-card": 797,
	"./icons/svg/Devices/SD-card.svg": 797,
	"./icons/svg/Devices/Server": 798,
	"./icons/svg/Devices/Server.svg": 798,
	"./icons/svg/Devices/Speaker": 799,
	"./icons/svg/Devices/Speaker.svg": 799,
	"./icons/svg/Devices/TV1": 800,
	"./icons/svg/Devices/TV1.svg": 800,
	"./icons/svg/Devices/TV2": 801,
	"./icons/svg/Devices/TV2.svg": 801,
	"./icons/svg/Devices/Tablet": 802,
	"./icons/svg/Devices/Tablet.svg": 802,
	"./icons/svg/Devices/USB": 803,
	"./icons/svg/Devices/USB.svg": 803,
	"./icons/svg/Devices/Usb-storage": 804,
	"./icons/svg/Devices/Usb-storage.svg": 804,
	"./icons/svg/Devices/Video-camera": 805,
	"./icons/svg/Devices/Video-camera.svg": 805,
	"./icons/svg/Devices/Watch1": 806,
	"./icons/svg/Devices/Watch1.svg": 806,
	"./icons/svg/Devices/Watch2": 807,
	"./icons/svg/Devices/Watch2.svg": 807,
	"./icons/svg/Devices/Wi-fi": 808,
	"./icons/svg/Devices/Wi-fi.svg": 808,
	"./icons/svg/Devices/iMac": 809,
	"./icons/svg/Devices/iMac.svg": 809,
	"./icons/svg/Devices/iPhone-X": 810,
	"./icons/svg/Devices/iPhone-X.svg": 810,
	"./icons/svg/Devices/iPhone-back": 811,
	"./icons/svg/Devices/iPhone-back.svg": 811,
	"./icons/svg/Devices/iPhone-x-back": 812,
	"./icons/svg/Devices/iPhone-x-back.svg": 812,
	"./icons/svg/Electric/Air-conditioning": 813,
	"./icons/svg/Electric/Air-conditioning.svg": 813,
	"./icons/svg/Electric/Blender": 814,
	"./icons/svg/Electric/Blender.svg": 814,
	"./icons/svg/Electric/Fan": 815,
	"./icons/svg/Electric/Fan.svg": 815,
	"./icons/svg/Electric/Fridge": 816,
	"./icons/svg/Electric/Fridge.svg": 816,
	"./icons/svg/Electric/Gas-stove": 817,
	"./icons/svg/Electric/Gas-stove.svg": 817,
	"./icons/svg/Electric/Highvoltage": 818,
	"./icons/svg/Electric/Highvoltage.svg": 818,
	"./icons/svg/Electric/Iron": 819,
	"./icons/svg/Electric/Iron.svg": 819,
	"./icons/svg/Electric/Kettle": 820,
	"./icons/svg/Electric/Kettle.svg": 820,
	"./icons/svg/Electric/Mixer": 821,
	"./icons/svg/Electric/Mixer.svg": 821,
	"./icons/svg/Electric/Outlet": 822,
	"./icons/svg/Electric/Outlet.svg": 822,
	"./icons/svg/Electric/Range-hood": 823,
	"./icons/svg/Electric/Range-hood.svg": 823,
	"./icons/svg/Electric/Shutdown": 824,
	"./icons/svg/Electric/Shutdown.svg": 824,
	"./icons/svg/Electric/Socket-eu": 825,
	"./icons/svg/Electric/Socket-eu.svg": 825,
	"./icons/svg/Electric/Socket-us": 826,
	"./icons/svg/Electric/Socket-us.svg": 826,
	"./icons/svg/Electric/Washer": 827,
	"./icons/svg/Electric/Washer.svg": 827,
	"./icons/svg/Electric/air-dryer": 828,
	"./icons/svg/Electric/air-dryer.svg": 828,
	"./icons/svg/Files/Cloud-download": 829,
	"./icons/svg/Files/Cloud-download.svg": 829,
	"./icons/svg/Files/Cloud-upload": 830,
	"./icons/svg/Files/Cloud-upload.svg": 830,
	"./icons/svg/Files/Compilation": 831,
	"./icons/svg/Files/Compilation.svg": 831,
	"./icons/svg/Files/Compiled-file": 832,
	"./icons/svg/Files/Compiled-file.svg": 832,
	"./icons/svg/Files/Deleted-file": 833,
	"./icons/svg/Files/Deleted-file.svg": 833,
	"./icons/svg/Files/Deleted-folder": 834,
	"./icons/svg/Files/Deleted-folder.svg": 834,
	"./icons/svg/Files/Download": 835,
	"./icons/svg/Files/Download.svg": 835,
	"./icons/svg/Files/DownloadedFile": 836,
	"./icons/svg/Files/DownloadedFile.svg": 836,
	"./icons/svg/Files/Downloads-folder": 837,
	"./icons/svg/Files/Downloads-folder.svg": 837,
	"./icons/svg/Files/Export": 838,
	"./icons/svg/Files/Export.svg": 838,
	"./icons/svg/Files/File": 839,
	"./icons/svg/Files/File-cloud": 840,
	"./icons/svg/Files/File-cloud.svg": 840,
	"./icons/svg/Files/File-done": 841,
	"./icons/svg/Files/File-done.svg": 841,
	"./icons/svg/Files/File-minus": 842,
	"./icons/svg/Files/File-minus.svg": 842,
	"./icons/svg/Files/File-plus": 843,
	"./icons/svg/Files/File-plus.svg": 843,
	"./icons/svg/Files/File.svg": 839,
	"./icons/svg/Files/Folder": 844,
	"./icons/svg/Files/Folder-check": 845,
	"./icons/svg/Files/Folder-check.svg": 845,
	"./icons/svg/Files/Folder-cloud": 846,
	"./icons/svg/Files/Folder-cloud.svg": 846,
	"./icons/svg/Files/Folder-error": 847,
	"./icons/svg/Files/Folder-error.svg": 847,
	"./icons/svg/Files/Folder-heart": 848,
	"./icons/svg/Files/Folder-heart.svg": 848,
	"./icons/svg/Files/Folder-minus": 849,
	"./icons/svg/Files/Folder-minus.svg": 849,
	"./icons/svg/Files/Folder-plus": 850,
	"./icons/svg/Files/Folder-plus.svg": 850,
	"./icons/svg/Files/Folder-solid": 851,
	"./icons/svg/Files/Folder-solid.svg": 851,
	"./icons/svg/Files/Folder-star": 852,
	"./icons/svg/Files/Folder-star.svg": 852,
	"./icons/svg/Files/Folder-thunder": 853,
	"./icons/svg/Files/Folder-thunder.svg": 853,
	"./icons/svg/Files/Folder.svg": 844,
	"./icons/svg/Files/Group-folders": 854,
	"./icons/svg/Files/Group-folders.svg": 854,
	"./icons/svg/Files/Import": 855,
	"./icons/svg/Files/Import.svg": 855,
	"./icons/svg/Files/Locked-folder": 856,
	"./icons/svg/Files/Locked-folder.svg": 856,
	"./icons/svg/Files/Media": 857,
	"./icons/svg/Files/Media-folder": 858,
	"./icons/svg/Files/Media-folder.svg": 858,
	"./icons/svg/Files/Media.svg": 857,
	"./icons/svg/Files/Music": 859,
	"./icons/svg/Files/Music.svg": 859,
	"./icons/svg/Files/Pictures1": 860,
	"./icons/svg/Files/Pictures1.svg": 860,
	"./icons/svg/Files/Pictures2": 861,
	"./icons/svg/Files/Pictures2.svg": 861,
	"./icons/svg/Files/Protected-file": 862,
	"./icons/svg/Files/Protected-file.svg": 862,
	"./icons/svg/Files/Selected-file": 863,
	"./icons/svg/Files/Selected-file.svg": 863,
	"./icons/svg/Files/Share": 864,
	"./icons/svg/Files/Share.svg": 864,
	"./icons/svg/Files/Upload": 865,
	"./icons/svg/Files/Upload-folder": 866,
	"./icons/svg/Files/Upload-folder.svg": 866,
	"./icons/svg/Files/Upload.svg": 865,
	"./icons/svg/Files/Uploaded-file": 867,
	"./icons/svg/Files/Uploaded-file.svg": 867,
	"./icons/svg/Files/User-folder": 868,
	"./icons/svg/Files/User-folder.svg": 868,
	"./icons/svg/Food/Beer": 869,
	"./icons/svg/Food/Beer.svg": 869,
	"./icons/svg/Food/Bottle1": 870,
	"./icons/svg/Food/Bottle1.svg": 870,
	"./icons/svg/Food/Bottle2": 871,
	"./icons/svg/Food/Bottle2.svg": 871,
	"./icons/svg/Food/Bread": 872,
	"./icons/svg/Food/Bread.svg": 872,
	"./icons/svg/Food/Bucket": 873,
	"./icons/svg/Food/Bucket.svg": 873,
	"./icons/svg/Food/Burger": 874,
	"./icons/svg/Food/Burger.svg": 874,
	"./icons/svg/Food/Cake": 875,
	"./icons/svg/Food/Cake.svg": 875,
	"./icons/svg/Food/Carrot": 876,
	"./icons/svg/Food/Carrot.svg": 876,
	"./icons/svg/Food/Cheese": 877,
	"./icons/svg/Food/Cheese.svg": 877,
	"./icons/svg/Food/Chicken": 878,
	"./icons/svg/Food/Chicken.svg": 878,
	"./icons/svg/Food/Coffee1": 879,
	"./icons/svg/Food/Coffee1.svg": 879,
	"./icons/svg/Food/Coffee2": 880,
	"./icons/svg/Food/Coffee2.svg": 880,
	"./icons/svg/Food/Cookie": 881,
	"./icons/svg/Food/Cookie.svg": 881,
	"./icons/svg/Food/Dinner": 882,
	"./icons/svg/Food/Dinner.svg": 882,
	"./icons/svg/Food/Fish": 883,
	"./icons/svg/Food/Fish.svg": 883,
	"./icons/svg/Food/French Bread": 884,
	"./icons/svg/Food/French Bread.svg": 884,
	"./icons/svg/Food/Glass-martini": 885,
	"./icons/svg/Food/Glass-martini.svg": 885,
	"./icons/svg/Food/Ice-cream1": 886,
	"./icons/svg/Food/Ice-cream1.svg": 886,
	"./icons/svg/Food/Ice-cream2": 887,
	"./icons/svg/Food/Ice-cream2.svg": 887,
	"./icons/svg/Food/Miso-soup": 888,
	"./icons/svg/Food/Miso-soup.svg": 888,
	"./icons/svg/Food/Orange": 889,
	"./icons/svg/Food/Orange.svg": 889,
	"./icons/svg/Food/Pizza": 890,
	"./icons/svg/Food/Pizza.svg": 890,
	"./icons/svg/Food/Sushi": 891,
	"./icons/svg/Food/Sushi.svg": 891,
	"./icons/svg/Food/Two-bottles": 892,
	"./icons/svg/Food/Two-bottles.svg": 892,
	"./icons/svg/Food/Wine": 893,
	"./icons/svg/Food/Wine.svg": 893,
	"./icons/svg/General/Attachment1": 894,
	"./icons/svg/General/Attachment1.svg": 894,
	"./icons/svg/General/Attachment2": 895,
	"./icons/svg/General/Attachment2.svg": 895,
	"./icons/svg/General/Binocular": 896,
	"./icons/svg/General/Binocular.svg": 896,
	"./icons/svg/General/Bookmark": 897,
	"./icons/svg/General/Bookmark.svg": 897,
	"./icons/svg/General/Clip": 898,
	"./icons/svg/General/Clip.svg": 898,
	"./icons/svg/General/Clipboard": 899,
	"./icons/svg/General/Clipboard.svg": 899,
	"./icons/svg/General/Cursor": 900,
	"./icons/svg/General/Cursor.svg": 900,
	"./icons/svg/General/Dislike": 901,
	"./icons/svg/General/Dislike.svg": 901,
	"./icons/svg/General/Duplicate": 902,
	"./icons/svg/General/Duplicate.svg": 902,
	"./icons/svg/General/Edit": 903,
	"./icons/svg/General/Edit.svg": 903,
	"./icons/svg/General/Expand-arrows": 904,
	"./icons/svg/General/Expand-arrows.svg": 904,
	"./icons/svg/General/Fire": 905,
	"./icons/svg/General/Fire.svg": 905,
	"./icons/svg/General/Folder": 906,
	"./icons/svg/General/Folder.svg": 906,
	"./icons/svg/General/Half-heart": 907,
	"./icons/svg/General/Half-heart.svg": 907,
	"./icons/svg/General/Half-star": 908,
	"./icons/svg/General/Half-star.svg": 908,
	"./icons/svg/General/Heart": 909,
	"./icons/svg/General/Heart.svg": 909,
	"./icons/svg/General/Hidden": 910,
	"./icons/svg/General/Hidden.svg": 910,
	"./icons/svg/General/Like": 911,
	"./icons/svg/General/Like.svg": 911,
	"./icons/svg/General/Lock": 912,
	"./icons/svg/General/Lock.svg": 912,
	"./icons/svg/General/Notification2": 913,
	"./icons/svg/General/Notification2.svg": 913,
	"./icons/svg/General/Notifications1": 914,
	"./icons/svg/General/Notifications1.svg": 914,
	"./icons/svg/General/Other1": 915,
	"./icons/svg/General/Other1.svg": 915,
	"./icons/svg/General/Other2": 916,
	"./icons/svg/General/Other2.svg": 916,
	"./icons/svg/General/Sad": 917,
	"./icons/svg/General/Sad.svg": 917,
	"./icons/svg/General/Save": 918,
	"./icons/svg/General/Save.svg": 918,
	"./icons/svg/General/Scale": 919,
	"./icons/svg/General/Scale.svg": 919,
	"./icons/svg/General/Scissors": 920,
	"./icons/svg/General/Scissors.svg": 920,
	"./icons/svg/General/Search": 921,
	"./icons/svg/General/Search.svg": 921,
	"./icons/svg/General/Settings#3": 922,
	"./icons/svg/General/Settings#3.svg": 922,
	"./icons/svg/General/Settings-1": 923,
	"./icons/svg/General/Settings-1.svg": 923,
	"./icons/svg/General/Settings-2": 924,
	"./icons/svg/General/Settings-2.svg": 924,
	"./icons/svg/General/Shield-check": 925,
	"./icons/svg/General/Shield-check.svg": 925,
	"./icons/svg/General/Shield-disabled": 926,
	"./icons/svg/General/Shield-disabled.svg": 926,
	"./icons/svg/General/Shield-protected": 927,
	"./icons/svg/General/Shield-protected.svg": 927,
	"./icons/svg/General/Size": 928,
	"./icons/svg/General/Size.svg": 928,
	"./icons/svg/General/Smile": 929,
	"./icons/svg/General/Smile.svg": 929,
	"./icons/svg/General/Star": 930,
	"./icons/svg/General/Star.svg": 930,
	"./icons/svg/General/Thunder": 931,
	"./icons/svg/General/Thunder-move": 932,
	"./icons/svg/General/Thunder-move.svg": 932,
	"./icons/svg/General/Thunder.svg": 931,
	"./icons/svg/General/Trash": 933,
	"./icons/svg/General/Trash.svg": 933,
	"./icons/svg/General/Unlock": 934,
	"./icons/svg/General/Unlock.svg": 934,
	"./icons/svg/General/Update": 935,
	"./icons/svg/General/Update.svg": 935,
	"./icons/svg/General/User": 936,
	"./icons/svg/General/User.svg": 936,
	"./icons/svg/General/Visible": 937,
	"./icons/svg/General/Visible.svg": 937,
	"./icons/svg/Home/Air-ballon": 938,
	"./icons/svg/Home/Air-ballon.svg": 938,
	"./icons/svg/Home/Alarm-clock": 939,
	"./icons/svg/Home/Alarm-clock.svg": 939,
	"./icons/svg/Home/Armchair": 940,
	"./icons/svg/Home/Armchair.svg": 940,
	"./icons/svg/Home/Bag-chair": 941,
	"./icons/svg/Home/Bag-chair.svg": 941,
	"./icons/svg/Home/Bath": 942,
	"./icons/svg/Home/Bath.svg": 942,
	"./icons/svg/Home/Bed": 943,
	"./icons/svg/Home/Bed.svg": 943,
	"./icons/svg/Home/Book": 944,
	"./icons/svg/Home/Book-open": 945,
	"./icons/svg/Home/Book-open.svg": 945,
	"./icons/svg/Home/Book.svg": 944,
	"./icons/svg/Home/Box": 946,
	"./icons/svg/Home/Box.svg": 946,
	"./icons/svg/Home/Broom": 947,
	"./icons/svg/Home/Broom.svg": 947,
	"./icons/svg/Home/Building": 948,
	"./icons/svg/Home/Building.svg": 948,
	"./icons/svg/Home/Bulb1": 949,
	"./icons/svg/Home/Bulb1.svg": 949,
	"./icons/svg/Home/Bulb2": 950,
	"./icons/svg/Home/Bulb2.svg": 950,
	"./icons/svg/Home/Chair1": 951,
	"./icons/svg/Home/Chair1.svg": 951,
	"./icons/svg/Home/Chair2": 952,
	"./icons/svg/Home/Chair2.svg": 952,
	"./icons/svg/Home/Clock": 953,
	"./icons/svg/Home/Clock.svg": 953,
	"./icons/svg/Home/Commode1": 954,
	"./icons/svg/Home/Commode1.svg": 954,
	"./icons/svg/Home/Commode2": 955,
	"./icons/svg/Home/Commode2.svg": 955,
	"./icons/svg/Home/Couch": 956,
	"./icons/svg/Home/Couch.svg": 956,
	"./icons/svg/Home/Cupboard": 957,
	"./icons/svg/Home/Cupboard.svg": 957,
	"./icons/svg/Home/Curtains": 958,
	"./icons/svg/Home/Curtains.svg": 958,
	"./icons/svg/Home/Deer": 959,
	"./icons/svg/Home/Deer.svg": 959,
	"./icons/svg/Home/Door-open": 960,
	"./icons/svg/Home/Door-open.svg": 960,
	"./icons/svg/Home/Earth": 961,
	"./icons/svg/Home/Earth.svg": 961,
	"./icons/svg/Home/Fireplace": 962,
	"./icons/svg/Home/Fireplace.svg": 962,
	"./icons/svg/Home/Flashlight": 963,
	"./icons/svg/Home/Flashlight.svg": 963,
	"./icons/svg/Home/Flower1": 964,
	"./icons/svg/Home/Flower1.svg": 964,
	"./icons/svg/Home/Flower2": 965,
	"./icons/svg/Home/Flower2.svg": 965,
	"./icons/svg/Home/Flower3": 966,
	"./icons/svg/Home/Flower3.svg": 966,
	"./icons/svg/Home/Globe": 967,
	"./icons/svg/Home/Globe.svg": 967,
	"./icons/svg/Home/Home": 968,
	"./icons/svg/Home/Home-heart": 969,
	"./icons/svg/Home/Home-heart.svg": 969,
	"./icons/svg/Home/Home.svg": 968,
	"./icons/svg/Home/Key": 970,
	"./icons/svg/Home/Key.svg": 970,
	"./icons/svg/Home/Ladder": 971,
	"./icons/svg/Home/Ladder.svg": 971,
	"./icons/svg/Home/Lamp1": 972,
	"./icons/svg/Home/Lamp1.svg": 972,
	"./icons/svg/Home/Lamp2": 973,
	"./icons/svg/Home/Lamp2.svg": 973,
	"./icons/svg/Home/Library": 974,
	"./icons/svg/Home/Library.svg": 974,
	"./icons/svg/Home/Mailbox": 975,
	"./icons/svg/Home/Mailbox.svg": 975,
	"./icons/svg/Home/Mirror": 976,
	"./icons/svg/Home/Mirror.svg": 976,
	"./icons/svg/Home/Picture": 977,
	"./icons/svg/Home/Picture.svg": 977,
	"./icons/svg/Home/Ruller": 978,
	"./icons/svg/Home/Ruller.svg": 978,
	"./icons/svg/Home/Stairs": 979,
	"./icons/svg/Home/Stairs.svg": 979,
	"./icons/svg/Home/Timer": 980,
	"./icons/svg/Home/Timer.svg": 980,
	"./icons/svg/Home/Toilet": 981,
	"./icons/svg/Home/Toilet.svg": 981,
	"./icons/svg/Home/Towel": 982,
	"./icons/svg/Home/Towel.svg": 982,
	"./icons/svg/Home/Trash": 983,
	"./icons/svg/Home/Trash.svg": 983,
	"./icons/svg/Home/Water-mixer": 984,
	"./icons/svg/Home/Water-mixer.svg": 984,
	"./icons/svg/Home/Weight1": 985,
	"./icons/svg/Home/Weight1.svg": 985,
	"./icons/svg/Home/Weight2": 986,
	"./icons/svg/Home/Weight2.svg": 986,
	"./icons/svg/Home/Wood-horse": 987,
	"./icons/svg/Home/Wood-horse.svg": 987,
	"./icons/svg/Home/Wood1": 988,
	"./icons/svg/Home/Wood1.svg": 988,
	"./icons/svg/Home/Wood2": 989,
	"./icons/svg/Home/Wood2.svg": 989,
	"./icons/svg/Layout/Layout-3d": 990,
	"./icons/svg/Layout/Layout-3d.svg": 990,
	"./icons/svg/Layout/Layout-4-blocks": 991,
	"./icons/svg/Layout/Layout-4-blocks.svg": 991,
	"./icons/svg/Layout/Layout-arrange": 992,
	"./icons/svg/Layout/Layout-arrange.svg": 992,
	"./icons/svg/Layout/Layout-grid": 993,
	"./icons/svg/Layout/Layout-grid.svg": 993,
	"./icons/svg/Layout/Layout-horizontal": 994,
	"./icons/svg/Layout/Layout-horizontal.svg": 994,
	"./icons/svg/Layout/Layout-left-panel-1": 995,
	"./icons/svg/Layout/Layout-left-panel-1.svg": 995,
	"./icons/svg/Layout/Layout-left-panel-2": 996,
	"./icons/svg/Layout/Layout-left-panel-2.svg": 996,
	"./icons/svg/Layout/Layout-right-panel-1": 997,
	"./icons/svg/Layout/Layout-right-panel-1.svg": 997,
	"./icons/svg/Layout/Layout-right-panel-2": 998,
	"./icons/svg/Layout/Layout-right-panel-2.svg": 998,
	"./icons/svg/Layout/Layout-top-panel-1": 999,
	"./icons/svg/Layout/Layout-top-panel-1.svg": 999,
	"./icons/svg/Layout/Layout-top-panel-2": 1000,
	"./icons/svg/Layout/Layout-top-panel-2.svg": 1000,
	"./icons/svg/Layout/Layout-top-panel-3": 1001,
	"./icons/svg/Layout/Layout-top-panel-3.svg": 1001,
	"./icons/svg/Layout/Layout-top-panel-4": 1002,
	"./icons/svg/Layout/Layout-top-panel-4.svg": 1002,
	"./icons/svg/Layout/Layout-top-panel-5": 1003,
	"./icons/svg/Layout/Layout-top-panel-5.svg": 1003,
	"./icons/svg/Layout/Layout-top-panel-6": 1004,
	"./icons/svg/Layout/Layout-top-panel-6.svg": 1004,
	"./icons/svg/Layout/Layout-vertical": 1005,
	"./icons/svg/Layout/Layout-vertical.svg": 1005,
	"./icons/svg/Map/Compass": 1006,
	"./icons/svg/Map/Compass.svg": 1006,
	"./icons/svg/Map/Direction1": 1007,
	"./icons/svg/Map/Direction1.svg": 1007,
	"./icons/svg/Map/Direction2": 1008,
	"./icons/svg/Map/Direction2.svg": 1008,
	"./icons/svg/Map/Location-arrow": 1009,
	"./icons/svg/Map/Location-arrow.svg": 1009,
	"./icons/svg/Map/Marker1": 1010,
	"./icons/svg/Map/Marker1.svg": 1010,
	"./icons/svg/Map/Marker2": 1011,
	"./icons/svg/Map/Marker2.svg": 1011,
	"./icons/svg/Map/Position": 1012,
	"./icons/svg/Map/Position.svg": 1012,
	"./icons/svg/Media/Add-music": 1013,
	"./icons/svg/Media/Add-music.svg": 1013,
	"./icons/svg/Media/Airplay": 1014,
	"./icons/svg/Media/Airplay-video": 1015,
	"./icons/svg/Media/Airplay-video.svg": 1015,
	"./icons/svg/Media/Airplay.svg": 1014,
	"./icons/svg/Media/Back": 1016,
	"./icons/svg/Media/Back.svg": 1016,
	"./icons/svg/Media/Backward": 1017,
	"./icons/svg/Media/Backward.svg": 1017,
	"./icons/svg/Media/CD": 1018,
	"./icons/svg/Media/CD.svg": 1018,
	"./icons/svg/Media/DVD": 1019,
	"./icons/svg/Media/DVD.svg": 1019,
	"./icons/svg/Media/Eject": 1020,
	"./icons/svg/Media/Eject.svg": 1020,
	"./icons/svg/Media/Equalizer": 1021,
	"./icons/svg/Media/Equalizer.svg": 1021,
	"./icons/svg/Media/Forward": 1022,
	"./icons/svg/Media/Forward.svg": 1022,
	"./icons/svg/Media/Media-library1": 1023,
	"./icons/svg/Media/Media-library1.svg": 1023,
	"./icons/svg/Media/Media-library2": 1024,
	"./icons/svg/Media/Media-library2.svg": 1024,
	"./icons/svg/Media/Media-library3": 1025,
	"./icons/svg/Media/Media-library3.svg": 1025,
	"./icons/svg/Media/Movie-Lane2": 1026,
	"./icons/svg/Media/Movie-Lane2.svg": 1026,
	"./icons/svg/Media/Movie-lane1": 1027,
	"./icons/svg/Media/Movie-lane1.svg": 1027,
	"./icons/svg/Media/Music": 1028,
	"./icons/svg/Media/Music-cloud": 1029,
	"./icons/svg/Media/Music-cloud.svg": 1029,
	"./icons/svg/Media/Music-note": 1030,
	"./icons/svg/Media/Music-note.svg": 1030,
	"./icons/svg/Media/Music.svg": 1028,
	"./icons/svg/Media/Mute": 1031,
	"./icons/svg/Media/Mute.svg": 1031,
	"./icons/svg/Media/Next": 1032,
	"./icons/svg/Media/Next.svg": 1032,
	"./icons/svg/Media/Pause": 1033,
	"./icons/svg/Media/Pause.svg": 1033,
	"./icons/svg/Media/Play": 1034,
	"./icons/svg/Media/Play.svg": 1034,
	"./icons/svg/Media/Playlist1": 1035,
	"./icons/svg/Media/Playlist1.svg": 1035,
	"./icons/svg/Media/Playlist2": 1036,
	"./icons/svg/Media/Playlist2.svg": 1036,
	"./icons/svg/Media/Rec": 1037,
	"./icons/svg/Media/Rec.svg": 1037,
	"./icons/svg/Media/Repeat": 1038,
	"./icons/svg/Media/Repeat-one": 1039,
	"./icons/svg/Media/Repeat-one.svg": 1039,
	"./icons/svg/Media/Repeat.svg": 1038,
	"./icons/svg/Media/Shuffle": 1040,
	"./icons/svg/Media/Shuffle.svg": 1040,
	"./icons/svg/Media/Volume-down": 1041,
	"./icons/svg/Media/Volume-down.svg": 1041,
	"./icons/svg/Media/Volume-full": 1042,
	"./icons/svg/Media/Volume-full.svg": 1042,
	"./icons/svg/Media/Volume-half": 1043,
	"./icons/svg/Media/Volume-half.svg": 1043,
	"./icons/svg/Media/Volume-up": 1044,
	"./icons/svg/Media/Volume-up.svg": 1044,
	"./icons/svg/Media/Vynil": 1045,
	"./icons/svg/Media/Vynil.svg": 1045,
	"./icons/svg/Media/Youtube": 1046,
	"./icons/svg/Media/Youtube.svg": 1046,
	"./icons/svg/Navigation/Angle-double-down": 1047,
	"./icons/svg/Navigation/Angle-double-down.svg": 1047,
	"./icons/svg/Navigation/Angle-double-left": 1048,
	"./icons/svg/Navigation/Angle-double-left.svg": 1048,
	"./icons/svg/Navigation/Angle-double-right": 1049,
	"./icons/svg/Navigation/Angle-double-right.svg": 1049,
	"./icons/svg/Navigation/Angle-double-up": 1050,
	"./icons/svg/Navigation/Angle-double-up.svg": 1050,
	"./icons/svg/Navigation/Angle-down": 1051,
	"./icons/svg/Navigation/Angle-down.svg": 1051,
	"./icons/svg/Navigation/Angle-left": 1052,
	"./icons/svg/Navigation/Angle-left.svg": 1052,
	"./icons/svg/Navigation/Angle-right": 1053,
	"./icons/svg/Navigation/Angle-right.svg": 1053,
	"./icons/svg/Navigation/Arrow-down": 1054,
	"./icons/svg/Navigation/Arrow-down.svg": 1054,
	"./icons/svg/Navigation/Arrow-from-bottom": 1055,
	"./icons/svg/Navigation/Arrow-from-bottom.svg": 1055,
	"./icons/svg/Navigation/Arrow-from-left": 1056,
	"./icons/svg/Navigation/Arrow-from-left.svg": 1056,
	"./icons/svg/Navigation/Arrow-from-right": 1057,
	"./icons/svg/Navigation/Arrow-from-right.svg": 1057,
	"./icons/svg/Navigation/Arrow-from-top": 1058,
	"./icons/svg/Navigation/Arrow-from-top.svg": 1058,
	"./icons/svg/Navigation/Arrow-left": 1059,
	"./icons/svg/Navigation/Arrow-left.svg": 1059,
	"./icons/svg/Navigation/Arrow-right": 1060,
	"./icons/svg/Navigation/Arrow-right.svg": 1060,
	"./icons/svg/Navigation/Arrow-to-bottom": 1061,
	"./icons/svg/Navigation/Arrow-to-bottom.svg": 1061,
	"./icons/svg/Navigation/Arrow-to-left": 1062,
	"./icons/svg/Navigation/Arrow-to-left.svg": 1062,
	"./icons/svg/Navigation/Arrow-to-right": 1063,
	"./icons/svg/Navigation/Arrow-to-right.svg": 1063,
	"./icons/svg/Navigation/Arrow-to-up": 1064,
	"./icons/svg/Navigation/Arrow-to-up.svg": 1064,
	"./icons/svg/Navigation/Arrow-up": 1065,
	"./icons/svg/Navigation/Arrow-up.svg": 1065,
	"./icons/svg/Navigation/Arrows-h": 1066,
	"./icons/svg/Navigation/Arrows-h.svg": 1066,
	"./icons/svg/Navigation/Arrows-v": 1067,
	"./icons/svg/Navigation/Arrows-v.svg": 1067,
	"./icons/svg/Navigation/Check": 1068,
	"./icons/svg/Navigation/Check.svg": 1068,
	"./icons/svg/Navigation/Close": 1069,
	"./icons/svg/Navigation/Close.svg": 1069,
	"./icons/svg/Navigation/Double-check": 1070,
	"./icons/svg/Navigation/Double-check.svg": 1070,
	"./icons/svg/Navigation/Down-2": 1071,
	"./icons/svg/Navigation/Down-2.svg": 1071,
	"./icons/svg/Navigation/Down-left": 1072,
	"./icons/svg/Navigation/Down-left.svg": 1072,
	"./icons/svg/Navigation/Down-right": 1073,
	"./icons/svg/Navigation/Down-right.svg": 1073,
	"./icons/svg/Navigation/Exchange": 1074,
	"./icons/svg/Navigation/Exchange.svg": 1074,
	"./icons/svg/Navigation/Left 3": 1075,
	"./icons/svg/Navigation/Left 3.svg": 1075,
	"./icons/svg/Navigation/Left-2": 1076,
	"./icons/svg/Navigation/Left-2.svg": 1076,
	"./icons/svg/Navigation/Minus": 1077,
	"./icons/svg/Navigation/Minus.svg": 1077,
	"./icons/svg/Navigation/Plus": 1078,
	"./icons/svg/Navigation/Plus.svg": 1078,
	"./icons/svg/Navigation/Right 3": 1079,
	"./icons/svg/Navigation/Right 3.svg": 1079,
	"./icons/svg/Navigation/Right-2": 1080,
	"./icons/svg/Navigation/Right-2.svg": 1080,
	"./icons/svg/Navigation/Route": 1081,
	"./icons/svg/Navigation/Route.svg": 1081,
	"./icons/svg/Navigation/Sign-in": 1082,
	"./icons/svg/Navigation/Sign-in.svg": 1082,
	"./icons/svg/Navigation/Sign-out": 1083,
	"./icons/svg/Navigation/Sign-out.svg": 1083,
	"./icons/svg/Navigation/Stockholm-icons/Navigation/Angle-up": 1084,
	"./icons/svg/Navigation/Stockholm-icons/Navigation/Angle-up.svg": 1084,
	"./icons/svg/Navigation/Up-2": 1085,
	"./icons/svg/Navigation/Up-2.svg": 1085,
	"./icons/svg/Navigation/Up-down": 1086,
	"./icons/svg/Navigation/Up-down.svg": 1086,
	"./icons/svg/Navigation/Up-left": 1087,
	"./icons/svg/Navigation/Up-left.svg": 1087,
	"./icons/svg/Navigation/Up-right": 1088,
	"./icons/svg/Navigation/Up-right.svg": 1088,
	"./icons/svg/Navigation/Waiting": 1089,
	"./icons/svg/Navigation/Waiting.svg": 1089,
	"./icons/svg/Shopping/ATM": 1090,
	"./icons/svg/Shopping/ATM.svg": 1090,
	"./icons/svg/Shopping/Bag1": 1091,
	"./icons/svg/Shopping/Bag1.svg": 1091,
	"./icons/svg/Shopping/Bag2": 1092,
	"./icons/svg/Shopping/Bag2.svg": 1092,
	"./icons/svg/Shopping/Barcode": 1093,
	"./icons/svg/Shopping/Barcode-read": 1094,
	"./icons/svg/Shopping/Barcode-read.svg": 1094,
	"./icons/svg/Shopping/Barcode-scan": 1095,
	"./icons/svg/Shopping/Barcode-scan.svg": 1095,
	"./icons/svg/Shopping/Barcode.svg": 1093,
	"./icons/svg/Shopping/Bitcoin": 1096,
	"./icons/svg/Shopping/Bitcoin.svg": 1096,
	"./icons/svg/Shopping/Box1": 1097,
	"./icons/svg/Shopping/Box1.svg": 1097,
	"./icons/svg/Shopping/Box2": 1098,
	"./icons/svg/Shopping/Box2.svg": 1098,
	"./icons/svg/Shopping/Box3": 1099,
	"./icons/svg/Shopping/Box3.svg": 1099,
	"./icons/svg/Shopping/Calculator": 1100,
	"./icons/svg/Shopping/Calculator.svg": 1100,
	"./icons/svg/Shopping/Cart1": 1101,
	"./icons/svg/Shopping/Cart1.svg": 1101,
	"./icons/svg/Shopping/Cart2": 1102,
	"./icons/svg/Shopping/Cart2.svg": 1102,
	"./icons/svg/Shopping/Cart3": 1103,
	"./icons/svg/Shopping/Cart3.svg": 1103,
	"./icons/svg/Shopping/Chart-bar1": 1104,
	"./icons/svg/Shopping/Chart-bar1.svg": 1104,
	"./icons/svg/Shopping/Chart-bar2": 1105,
	"./icons/svg/Shopping/Chart-bar2.svg": 1105,
	"./icons/svg/Shopping/Chart-bar3": 1106,
	"./icons/svg/Shopping/Chart-bar3.svg": 1106,
	"./icons/svg/Shopping/Chart-line1": 1107,
	"./icons/svg/Shopping/Chart-line1.svg": 1107,
	"./icons/svg/Shopping/Chart-line2": 1108,
	"./icons/svg/Shopping/Chart-line2.svg": 1108,
	"./icons/svg/Shopping/Chart-pie": 1109,
	"./icons/svg/Shopping/Chart-pie.svg": 1109,
	"./icons/svg/Shopping/Credit-card": 1110,
	"./icons/svg/Shopping/Credit-card.svg": 1110,
	"./icons/svg/Shopping/Dollar": 1111,
	"./icons/svg/Shopping/Dollar.svg": 1111,
	"./icons/svg/Shopping/Euro": 1112,
	"./icons/svg/Shopping/Euro.svg": 1112,
	"./icons/svg/Shopping/Gift": 1113,
	"./icons/svg/Shopping/Gift.svg": 1113,
	"./icons/svg/Shopping/Loader": 1114,
	"./icons/svg/Shopping/Loader.svg": 1114,
	"./icons/svg/Shopping/MC": 1115,
	"./icons/svg/Shopping/MC.svg": 1115,
	"./icons/svg/Shopping/Money": 1116,
	"./icons/svg/Shopping/Money.svg": 1116,
	"./icons/svg/Shopping/Pound": 1117,
	"./icons/svg/Shopping/Pound.svg": 1117,
	"./icons/svg/Shopping/Price1": 1118,
	"./icons/svg/Shopping/Price1.svg": 1118,
	"./icons/svg/Shopping/Price2": 1119,
	"./icons/svg/Shopping/Price2.svg": 1119,
	"./icons/svg/Shopping/Rouble": 1120,
	"./icons/svg/Shopping/Rouble.svg": 1120,
	"./icons/svg/Shopping/Safe": 1121,
	"./icons/svg/Shopping/Safe.svg": 1121,
	"./icons/svg/Shopping/Sale1": 1122,
	"./icons/svg/Shopping/Sale1.svg": 1122,
	"./icons/svg/Shopping/Sale2": 1123,
	"./icons/svg/Shopping/Sale2.svg": 1123,
	"./icons/svg/Shopping/Settings": 1124,
	"./icons/svg/Shopping/Settings.svg": 1124,
	"./icons/svg/Shopping/Sort1": 1125,
	"./icons/svg/Shopping/Sort1.svg": 1125,
	"./icons/svg/Shopping/Sort2": 1126,
	"./icons/svg/Shopping/Sort2.svg": 1126,
	"./icons/svg/Shopping/Sort3": 1127,
	"./icons/svg/Shopping/Sort3.svg": 1127,
	"./icons/svg/Shopping/Ticket": 1128,
	"./icons/svg/Shopping/Ticket.svg": 1128,
	"./icons/svg/Shopping/Wallet": 1129,
	"./icons/svg/Shopping/Wallet.svg": 1129,
	"./icons/svg/Shopping/Wallet2": 1130,
	"./icons/svg/Shopping/Wallet2.svg": 1130,
	"./icons/svg/Shopping/Wallet3": 1131,
	"./icons/svg/Shopping/Wallet3.svg": 1131,
	"./icons/svg/Text/Align-auto": 1132,
	"./icons/svg/Text/Align-auto.svg": 1132,
	"./icons/svg/Text/Align-center": 1133,
	"./icons/svg/Text/Align-center.svg": 1133,
	"./icons/svg/Text/Align-justify": 1134,
	"./icons/svg/Text/Align-justify.svg": 1134,
	"./icons/svg/Text/Align-left": 1135,
	"./icons/svg/Text/Align-left.svg": 1135,
	"./icons/svg/Text/Align-right": 1136,
	"./icons/svg/Text/Align-right.svg": 1136,
	"./icons/svg/Text/Article": 1137,
	"./icons/svg/Text/Article.svg": 1137,
	"./icons/svg/Text/Bold": 1138,
	"./icons/svg/Text/Bold.svg": 1138,
	"./icons/svg/Text/Bullet-list": 1139,
	"./icons/svg/Text/Bullet-list.svg": 1139,
	"./icons/svg/Text/Code": 1140,
	"./icons/svg/Text/Code.svg": 1140,
	"./icons/svg/Text/Edit-text": 1141,
	"./icons/svg/Text/Edit-text.svg": 1141,
	"./icons/svg/Text/Filter": 1142,
	"./icons/svg/Text/Filter.svg": 1142,
	"./icons/svg/Text/Font": 1143,
	"./icons/svg/Text/Font.svg": 1143,
	"./icons/svg/Text/H1": 1144,
	"./icons/svg/Text/H1.svg": 1144,
	"./icons/svg/Text/H2": 1145,
	"./icons/svg/Text/H2.svg": 1145,
	"./icons/svg/Text/Itallic": 1146,
	"./icons/svg/Text/Itallic.svg": 1146,
	"./icons/svg/Text/Menu": 1147,
	"./icons/svg/Text/Menu.svg": 1147,
	"./icons/svg/Text/Paragraph": 1148,
	"./icons/svg/Text/Paragraph.svg": 1148,
	"./icons/svg/Text/Quote1": 1149,
	"./icons/svg/Text/Quote1.svg": 1149,
	"./icons/svg/Text/Quote2": 1150,
	"./icons/svg/Text/Quote2.svg": 1150,
	"./icons/svg/Text/Redo": 1151,
	"./icons/svg/Text/Redo.svg": 1151,
	"./icons/svg/Text/Strikethrough": 1152,
	"./icons/svg/Text/Strikethrough.svg": 1152,
	"./icons/svg/Text/Text": 1153,
	"./icons/svg/Text/Text-height": 1154,
	"./icons/svg/Text/Text-height.svg": 1154,
	"./icons/svg/Text/Text-width": 1155,
	"./icons/svg/Text/Text-width.svg": 1155,
	"./icons/svg/Text/Text.svg": 1153,
	"./icons/svg/Text/Underline": 1156,
	"./icons/svg/Text/Underline.svg": 1156,
	"./icons/svg/Text/Undo": 1157,
	"./icons/svg/Text/Undo.svg": 1157,
	"./icons/svg/Tools/Angle Grinder": 1158,
	"./icons/svg/Tools/Angle Grinder.svg": 1158,
	"./icons/svg/Tools/Axe": 1159,
	"./icons/svg/Tools/Axe.svg": 1159,
	"./icons/svg/Tools/Brush": 1160,
	"./icons/svg/Tools/Brush.svg": 1160,
	"./icons/svg/Tools/Compass": 1161,
	"./icons/svg/Tools/Compass.svg": 1161,
	"./icons/svg/Tools/Hummer": 1162,
	"./icons/svg/Tools/Hummer.svg": 1162,
	"./icons/svg/Tools/Hummer2": 1163,
	"./icons/svg/Tools/Hummer2.svg": 1163,
	"./icons/svg/Tools/Pantone": 1164,
	"./icons/svg/Tools/Pantone.svg": 1164,
	"./icons/svg/Tools/Road-Cone": 1165,
	"./icons/svg/Tools/Road-Cone.svg": 1165,
	"./icons/svg/Tools/Roller": 1166,
	"./icons/svg/Tools/Roller.svg": 1166,
	"./icons/svg/Tools/Roulette": 1167,
	"./icons/svg/Tools/Roulette.svg": 1167,
	"./icons/svg/Tools/Screwdriver": 1168,
	"./icons/svg/Tools/Screwdriver.svg": 1168,
	"./icons/svg/Tools/Shovel": 1169,
	"./icons/svg/Tools/Shovel.svg": 1169,
	"./icons/svg/Tools/Spatula": 1170,
	"./icons/svg/Tools/Spatula.svg": 1170,
	"./icons/svg/Tools/Swiss-knife": 1171,
	"./icons/svg/Tools/Swiss-knife.svg": 1171,
	"./icons/svg/Tools/Tools": 1172,
	"./icons/svg/Tools/Tools.svg": 1172,
	"./icons/svg/Weather/Celcium": 1173,
	"./icons/svg/Weather/Celcium.svg": 1173,
	"./icons/svg/Weather/Cloud-fog": 1174,
	"./icons/svg/Weather/Cloud-fog.svg": 1174,
	"./icons/svg/Weather/Cloud-sun": 1175,
	"./icons/svg/Weather/Cloud-sun.svg": 1175,
	"./icons/svg/Weather/Cloud-wind": 1176,
	"./icons/svg/Weather/Cloud-wind.svg": 1176,
	"./icons/svg/Weather/Cloud1": 1177,
	"./icons/svg/Weather/Cloud1.svg": 1177,
	"./icons/svg/Weather/Cloud2": 1178,
	"./icons/svg/Weather/Cloud2.svg": 1178,
	"./icons/svg/Weather/Cloudy": 1179,
	"./icons/svg/Weather/Cloudy-night": 1180,
	"./icons/svg/Weather/Cloudy-night.svg": 1180,
	"./icons/svg/Weather/Cloudy.svg": 1179,
	"./icons/svg/Weather/Day-rain": 1181,
	"./icons/svg/Weather/Day-rain.svg": 1181,
	"./icons/svg/Weather/Fahrenheit": 1182,
	"./icons/svg/Weather/Fahrenheit.svg": 1182,
	"./icons/svg/Weather/Fog": 1183,
	"./icons/svg/Weather/Fog.svg": 1183,
	"./icons/svg/Weather/Moon": 1184,
	"./icons/svg/Weather/Moon.svg": 1184,
	"./icons/svg/Weather/Night-fog": 1185,
	"./icons/svg/Weather/Night-fog.svg": 1185,
	"./icons/svg/Weather/Night-rain": 1186,
	"./icons/svg/Weather/Night-rain.svg": 1186,
	"./icons/svg/Weather/Rain1": 1187,
	"./icons/svg/Weather/Rain1.svg": 1187,
	"./icons/svg/Weather/Rain2": 1188,
	"./icons/svg/Weather/Rain2.svg": 1188,
	"./icons/svg/Weather/Rain5": 1189,
	"./icons/svg/Weather/Rain5.svg": 1189,
	"./icons/svg/Weather/Rainbow": 1190,
	"./icons/svg/Weather/Rainbow.svg": 1190,
	"./icons/svg/Weather/Snow": 1191,
	"./icons/svg/Weather/Snow.svg": 1191,
	"./icons/svg/Weather/Snow1": 1192,
	"./icons/svg/Weather/Snow1.svg": 1192,
	"./icons/svg/Weather/Snow2": 1193,
	"./icons/svg/Weather/Snow2.svg": 1193,
	"./icons/svg/Weather/Snow3": 1194,
	"./icons/svg/Weather/Snow3.svg": 1194,
	"./icons/svg/Weather/Storm": 1195,
	"./icons/svg/Weather/Storm.svg": 1195,
	"./icons/svg/Weather/Sun": 1196,
	"./icons/svg/Weather/Sun-fog": 1197,
	"./icons/svg/Weather/Sun-fog.svg": 1197,
	"./icons/svg/Weather/Sun.svg": 1196,
	"./icons/svg/Weather/Suset1": 1198,
	"./icons/svg/Weather/Suset1.svg": 1198,
	"./icons/svg/Weather/Suset2": 1199,
	"./icons/svg/Weather/Suset2.svg": 1199,
	"./icons/svg/Weather/Temperature-empty": 1200,
	"./icons/svg/Weather/Temperature-empty.svg": 1200,
	"./icons/svg/Weather/Temperature-full": 1201,
	"./icons/svg/Weather/Temperature-full.svg": 1201,
	"./icons/svg/Weather/Temperature-half": 1202,
	"./icons/svg/Weather/Temperature-half.svg": 1202,
	"./icons/svg/Weather/Thunder": 1203,
	"./icons/svg/Weather/Thunder-night": 1204,
	"./icons/svg/Weather/Thunder-night.svg": 1204,
	"./icons/svg/Weather/Thunder.svg": 1203,
	"./icons/svg/Weather/Umbrella": 1205,
	"./icons/svg/Weather/Umbrella.svg": 1205,
	"./icons/svg/Weather/Wind": 1206,
	"./icons/svg/Weather/Wind.svg": 1206,
	"./icons/warning": 1207,
	"./icons/warning.svg": 1207,
	"./illustrations/contact": 1208,
	"./illustrations/contact.svg": 1208,
	"./illustrations/data-points": 1209,
	"./illustrations/data-points.svg": 1209,
	"./illustrations/working": 1210,
	"./illustrations/working.svg": 1210,
	"./logos/favicon.ico": 1443,
	"./logos/logo-10": 1211,
	"./logos/logo-10-sm": 1212,
	"./logos/logo-10-sm.png": 1212,
	"./logos/logo-10.png": 1211,
	"./logos/logo-11": 1213,
	"./logos/logo-11-sm": 1214,
	"./logos/logo-11-sm.png": 1214,
	"./logos/logo-11.png": 1213,
	"./logos/logo-12": 1215,
	"./logos/logo-12.png": 1215,
	"./logos/logo-2": 1216,
	"./logos/logo-2-sm": 1217,
	"./logos/logo-2-sm.png": 1217,
	"./logos/logo-2.png": 1216,
	"./logos/logo-3": 1218,
	"./logos/logo-3.png": 1218,
	"./logos/logo-4": 1219,
	"./logos/logo-4-sm": 1220,
	"./logos/logo-4-sm.png": 1220,
	"./logos/logo-4.png": 1219,
	"./logos/logo-5": 1221,
	"./logos/logo-5-sm": 1222,
	"./logos/logo-5-sm.png": 1222,
	"./logos/logo-5.png": 1221,
	"./logos/logo-6": 1223,
	"./logos/logo-6-sm": 1224,
	"./logos/logo-6-sm.png": 1224,
	"./logos/logo-6.png": 1223,
	"./logos/logo-7": 1225,
	"./logos/logo-7-sm": 1226,
	"./logos/logo-7-sm.png": 1226,
	"./logos/logo-7.png": 1225,
	"./logos/logo-8": 1227,
	"./logos/logo-8-inverse": 1228,
	"./logos/logo-8-inverse.png": 1228,
	"./logos/logo-8-sm": 1229,
	"./logos/logo-8-sm.png": 1229,
	"./logos/logo-8.png": 1227,
	"./logos/logo-9": 1230,
	"./logos/logo-9-sm": 1231,
	"./logos/logo-9-sm.png": 1231,
	"./logos/logo-9.png": 1230,
	"./logos/logo-dark": 1232,
	"./logos/logo-dark-sm": 1233,
	"./logos/logo-dark-sm.png": 1233,
	"./logos/logo-dark.png": 1232,
	"./logos/logo-light": 1234,
	"./logos/logo-light-sm": 1235,
	"./logos/logo-light-sm.png": 1235,
	"./logos/logo-light.png": 1234,
	"./logos/logo-mini-2-md": 1236,
	"./logos/logo-mini-2-md.png": 1236,
	"./logos/logo-mini-lg": 1237,
	"./logos/logo-mini-lg.png": 1237,
	"./logos/logo-mini-md": 1238,
	"./logos/logo-mini-md.png": 1238,
	"./logos/logo-mini-sm": 1239,
	"./logos/logo-mini-sm.png": 1239,
	"./misc/bg-1": 1240,
	"./misc/bg-1.jpg": 1240,
	"./misc/bg-2": 1241,
	"./misc/bg-2.jpg": 1241,
	"./misc/owl.video.play": 1242,
	"./misc/owl.video.play.png": 1242,
	"./plugins/jstree/32px": 1243,
	"./plugins/jstree/32px.png": 1243,
	"./products/product1": 1244,
	"./products/product1.jpg": 1244,
	"./products/product10": 1245,
	"./products/product10.jpg": 1245,
	"./products/product11": 1246,
	"./products/product11.jpg": 1246,
	"./products/product12": 1247,
	"./products/product12.jpg": 1247,
	"./products/product13": 1248,
	"./products/product13.jpg": 1248,
	"./products/product14": 1249,
	"./products/product14.jpg": 1249,
	"./products/product15": 1250,
	"./products/product15.jpg": 1250,
	"./products/product16": 1251,
	"./products/product16.jpg": 1251,
	"./products/product17": 1252,
	"./products/product17.jpg": 1252,
	"./products/product18": 1253,
	"./products/product18.jpg": 1253,
	"./products/product19": 1254,
	"./products/product19.jpg": 1254,
	"./products/product2": 1255,
	"./products/product2.jpg": 1255,
	"./products/product20": 1256,
	"./products/product20.jpg": 1256,
	"./products/product21": 1257,
	"./products/product21.jpg": 1257,
	"./products/product22": 1258,
	"./products/product22.jpg": 1258,
	"./products/product23": 1259,
	"./products/product23.jpg": 1259,
	"./products/product24": 1260,
	"./products/product24.jpg": 1260,
	"./products/product25": 1261,
	"./products/product25.jpg": 1261,
	"./products/product26": 1262,
	"./products/product26.jpg": 1262,
	"./products/product27": 1263,
	"./products/product27.jpg": 1263,
	"./products/product28": 1264,
	"./products/product28.jpg": 1264,
	"./products/product3": 1265,
	"./products/product3.jpg": 1265,
	"./products/product4": 1266,
	"./products/product4.jpg": 1266,
	"./products/product5": 1267,
	"./products/product5.jpg": 1267,
	"./products/product6": 1268,
	"./products/product6.jpg": 1268,
	"./products/product7": 1269,
	"./products/product7.jpg": 1269,
	"./products/product8": 1270,
	"./products/product8.jpg": 1270,
	"./products/product9": 1271,
	"./products/product9.jpg": 1271,
	"./project-logos/1": 1272,
	"./project-logos/1.png": 1272,
	"./project-logos/2": 1273,
	"./project-logos/2.png": 1273,
	"./project-logos/3": 1274,
	"./project-logos/3.png": 1274,
	"./project-logos/4": 1275,
	"./project-logos/4.png": 1275,
	"./project-logos/5": 1276,
	"./project-logos/5.png": 1276,
	"./project-logos/6": 1277,
	"./project-logos/6.png": 1277,
	"./project-logos/7": 1278,
	"./project-logos/7.png": 1278,
	"./users/100_1": 1279,
	"./users/100_1.jpg": 1279,
	"./users/100_10": 1280,
	"./users/100_10.jpg": 1280,
	"./users/100_11": 1281,
	"./users/100_11.jpg": 1281,
	"./users/100_12": 1282,
	"./users/100_12.jpg": 1282,
	"./users/100_13": 1283,
	"./users/100_13.jpg": 1283,
	"./users/100_14": 1284,
	"./users/100_14.jpg": 1284,
	"./users/100_2": 1285,
	"./users/100_2.jpg": 1285,
	"./users/100_3": 1286,
	"./users/100_3.jpg": 1286,
	"./users/100_4": 1287,
	"./users/100_4.jpg": 1287,
	"./users/100_5": 1288,
	"./users/100_5.jpg": 1288,
	"./users/100_6": 1289,
	"./users/100_6.jpg": 1289,
	"./users/100_7": 1290,
	"./users/100_7.jpg": 1290,
	"./users/100_8": 1291,
	"./users/100_8.jpg": 1291,
	"./users/100_9": 1292,
	"./users/100_9.jpg": 1292,
	"./users/300_1": 1293,
	"./users/300_1.jpg": 1293,
	"./users/300_10": 1294,
	"./users/300_10.jpg": 1294,
	"./users/300_11": 1295,
	"./users/300_11.jpg": 1295,
	"./users/300_12": 1296,
	"./users/300_12.jpg": 1296,
	"./users/300_13": 1297,
	"./users/300_13.jpg": 1297,
	"./users/300_14": 1298,
	"./users/300_14.jpg": 1298,
	"./users/300_15": 1299,
	"./users/300_15.jpg": 1299,
	"./users/300_16": 1300,
	"./users/300_16.jpg": 1300,
	"./users/300_17": 1301,
	"./users/300_17.jpg": 1301,
	"./users/300_18": 1302,
	"./users/300_18.jpg": 1302,
	"./users/300_19": 1303,
	"./users/300_19.jpg": 1303,
	"./users/300_2": 1304,
	"./users/300_2.jpg": 1304,
	"./users/300_20": 1305,
	"./users/300_20.jpg": 1305,
	"./users/300_21": 1306,
	"./users/300_21.jpg": 1306,
	"./users/300_22": 1307,
	"./users/300_22.jpg": 1307,
	"./users/300_23": 1308,
	"./users/300_23.jpg": 1308,
	"./users/300_24": 1309,
	"./users/300_24.jpg": 1309,
	"./users/300_25": 1310,
	"./users/300_25.jpg": 1310,
	"./users/300_3": 1311,
	"./users/300_3.jpg": 1311,
	"./users/300_4": 1312,
	"./users/300_4.jpg": 1312,
	"./users/300_5": 1313,
	"./users/300_5.jpg": 1313,
	"./users/300_6": 1314,
	"./users/300_6.jpg": 1314,
	"./users/300_7": 1315,
	"./users/300_7.jpg": 1315,
	"./users/300_8": 1316,
	"./users/300_8.jpg": 1316,
	"./users/300_9": 1317,
	"./users/300_9.jpg": 1317,
	"./users/default": 1318,
	"./users/default.jpg": 1318,
	"./users/user1": 1319,
	"./users/user1.jpg": 1319,
	"./users/user2": 1320,
	"./users/user2.jpg": 1320,
	"./users/user3": 1321,
	"./users/user3.jpg": 1321,
	"./users/user4": 1322,
	"./users/user4.jpg": 1322,
	"./users/user5": 1323,
	"./users/user5.jpg": 1323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1441;